{
    "simulations": [
        {
            "uuid": "ab5f34b6-e4c4-4ad3-a249-4abaaeb84ef3",
            "name": "My simulation 1",
            "billionsOfSimulations": 10,
            "billionsOfSimulationsLeft": 0,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-02-20T11:39:17.171",
            "beginTime": "2023-02-20T11:49:17.171",
            "endTime": "2023-02-20T11:59:17.171",
            "simulationType": "TWO_DIMENSION_BP",
            "dt": 5,
            "kparKper": null,
            "k0": 5e+22,
            "v": 400,
            "finished": true
        },
        {
            "uuid": "1a452cbe-b72d-4e20-94d6-91a4e5e0414e",
            "name": "Đ My simulation 2 name too long to render properly and probably breaks layout",
            "billionsOfSimulations": 10,
            "billionsOfSimulationsLeft": 2.68,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-02-18T11:49:17.171",
            "beginTime": "2023-04-18T11:59:17.171",
            "endTime": null,
            "simulationType": "ONE_DIMENSION_BP",
            "dt": 480,
            "kparKper": 0.06,
            "k0": 5e+22,
            "v": 1400,
            "finished": false
        },
        {
            "uuid": "b4f797b7-cc26-4fae-a4db-49b413e124b8",
            "name": "Á My simulation #3️⃣<掳𘏑򇫞㣞טQ𼉵󜕄򪛦𒚤򗟸췼񜢩窖낯᚟s¤ݓ𤡜",
            "billionsOfSimulations": 10,
            "billionsOfSimulationsLeft": 10,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-02-05T11:59:17.171",
            "beginTime": null,
            "endTime": null,
            "simulationType": "ONE_DIMENSION_FP",
            "dt": 5,
            "kparKper": 0.01,
            "k0": 5e+22,
            "v": 400,
            "finished": false
        },
        {
            "uuid": "s4f797b7-cc26-4fae-a4db-49b413e124b8",
            "name": "My simulation 4",
            "billionsOfSimulations": 10,
            "billionsOfSimulationsLeft": 10,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-01-22T11:39:17.171",
            "beginTime": "2023-01-22T11:49:17.171",
            "endTime": "2023-01-22T11:59:17.171",
            "simulationType": "TWO_DIMENSION_FP",
            "dt": 5,
            "kparKper": 0.01,
            "k0": 5e+22,
            "v": 400,
            "finished": false
        },
        {
            "uuid": "ad53394c-2f51-4fb1-897e-969d116d3bd2",
            "name": "Simulation Ranunculaceae",
            "billionsOfSimulations": 51,
            "billionsOfSimulationsLeft": 15,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2022-11-14T14:02:27Z",
            "beginTime": null,
            "endTime": null,
            "simulationType": "TWO_DIMENSION_FP",
            "dt": 147,
            "v": 919,
            "k0": 1.7,
            "kparKper": 0.06,
            "mu": 0.9,
            "finished": false
        },
        {
            "uuid": "3942a31b-20ec-453a-98b5-37dcf23d95d4",
            "name": "Simulation Cyperaceae",
            "billionsOfSimulations": 28,
            "billionsOfSimulationsLeft": 28,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2022-11-20T12:47:18Z",
            "beginTime": "2023-03-31T12:13:29Z",
            "endTime": "2023-04-17T06:45:10Z",
            "simulationType": "ONE_DIMENSION_BP",
            "dt": 388,
            "v": 856,
            "k0": 6.1,
            "kparKper": 0.06,
            "mu": 0.5,
            "finished": true
        },
        {
            "uuid": "78893c46-e1b6-40f9-876e-944fdfd1224b",
            "name": "Simulation Poaceae",
            "billionsOfSimulations": 33,
            "billionsOfSimulationsLeft": 8,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-02-20T18:17:24Z",
            "beginTime": "2023-03-15T01:21:11Z",
            "endTime": "2023-04-13T06:11:01Z",
            "simulationType": "ONE_DIMENSION_BP",
            "dt": 630,
            "v": 785,
            "k0": 1.5,
            "kparKper": 0.05,
            "mu": 0.3,
            "finished": true
        },
        {
            "uuid": "afe0490a-8937-4e4c-b06d-56207fd6a5b3",
            "name": "Simulation Asteraceae",
            "billionsOfSimulations": 16,
            "billionsOfSimulationsLeft": 16,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-01-26T03:00:55Z",
            "beginTime": "2023-04-10T15:24:33Z",
            "endTime": "2023-04-18T10:29:31Z",
            "simulationType": "TWO_DIMENSION_FP",
            "dt": 568,
            "v": 468,
            "k0": 8.9,
            "kparKper": 0.03,
            "mu": 0.5,
            "finished": true
        },
        {
            "uuid": "844e39b4-ad16-41ae-9e46-a61532040246",
            "name": "Simulation Polygalaceae",
            "billionsOfSimulations": 5,
            "billionsOfSimulationsLeft": 1,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-01-27T17:33:39Z",
            "beginTime": "2023-04-10T14:30:14Z",
            "endTime": null,
            "simulationType": "ONE_DIMENSION_FP",
            "dt": 250,
            "v": 970,
            "k0": 1.2,
            "kparKper": 0.1,
            "mu": 0.6,
            "finished": false
        },
        {
            "uuid": "baef2208-4f39-42f5-8f23-03814b52a553",
            "name": "Simulation Pittosporaceae",
            "billionsOfSimulations": 57,
            "billionsOfSimulationsLeft": 30,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2022-11-23T02:11:06Z",
            "beginTime": "2023-04-03T03:36:28Z",
            "endTime": "2023-04-12T07:26:41Z",
            "simulationType": "TWO_DIMENSION_FT",
            "dt": 20,
            "v": 704,
            "k0": 2.2,
            "kparKper": 0.07,
            "mu": 0.4,
            "finished": true
        },
        {
            "uuid": "7e14b1c7-01d4-4cdb-a235-673ba6e74f15",
            "name": "Simulation Liliaceae",
            "billionsOfSimulations": 29,
            "billionsOfSimulationsLeft": 29,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-01-09T13:10:53Z",
            "beginTime": "2023-03-14T14:30:51Z",
            "endTime": null,
            "simulationType": "ONE_DIMENSION_FP",
            "dt": 567,
            "v": 200,
            "k0": 8.0,
            "kparKper": 0.08,
            "mu": 0.7,
            "finished": false
        },
        {
            "uuid": "9566b7a7-6bae-445d-b819-38578a70feac",
            "name": "Simulation Fabaceae",
            "billionsOfSimulations": 87,
            "billionsOfSimulationsLeft": 55,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2022-12-18T10:36:33Z",
            "beginTime": "2023-03-31T09:38:27Z",
            "endTime": "2023-04-13T16:10:29Z",
            "simulationType": "TWO_DIMENSION_FT",
            "dt": 5,
            "v": 1087,
            "k0": 7.4,
            "kparKper": 0.02,
            "mu": 0.6,
            "finished": true
        },
        {
            "uuid": "494709db-c99d-4f5c-8ff9-cc3d96bfb872",
            "name": "Simulation Cyperaceae",
            "billionsOfSimulations": 50,
            "billionsOfSimulationsLeft": 12,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2022-11-21T10:28:08Z",
            "beginTime": null,
            "endTime": null,
            "simulationType": "ONE_DIMENSION_BP",
            "dt": 273,
            "v": 133,
            "k0": 1.2,
            "kparKper": 0.01,
            "mu": 0.5,
            "finished": false
        },
        {
            "uuid": "3e5d31eb-d0fa-408c-8a96-11b8f165d347",
            "name": "Simulation Poaceae",
            "billionsOfSimulations": 47,
            "billionsOfSimulationsLeft": 17,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-03-01T01:00:01Z",
            "beginTime": "2023-04-06T09:31:12Z",
            "endTime": null,
            "simulationType": "TWO_DIMENSION_FP",
            "dt": 821,
            "v": 887,
            "k0": 3.8,
            "kparKper": 0.06,
            "mu": 0.3,
            "finished": false
        },
        {
            "uuid": "9e4a186c-f6f1-4dac-af85-7bc43441c907",
            "name": "Simulation Asteraceae",
            "billionsOfSimulations": 51,
            "billionsOfSimulationsLeft": 29,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2022-10-25T10:07:34Z",
            "beginTime": "2023-03-25T08:47:39Z",
            "endTime": null,
            "simulationType": "TWO_DIMENSION_FT",
            "dt": 258,
            "v": 104,
            "k0": 3.4,
            "kparKper": 0.08,
            "mu": 0.2,
            "finished": false
        },
        {
            "uuid": "f04420cf-2888-40ee-9c50-1c1f78ce3dfc",
            "name": "Simulation Polemoniaceae",
            "billionsOfSimulations": 66,
            "billionsOfSimulationsLeft": 66,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2022-10-23T04:35:00Z",
            "beginTime": "2023-03-16T03:29:37Z",
            "endTime": null,
            "simulationType": "TWO_DIMENSION_FP",
            "dt": 263,
            "v": 365,
            "k0": 6.2,
            "kparKper": 0.05,
            "mu": 0.8,
            "finished": false
        },
        {
            "uuid": "6196d70e-e240-439b-b6cd-bdddd6d1d8e9",
            "name": "Simulation Polytrichaceae",
            "billionsOfSimulations": 69,
            "billionsOfSimulationsLeft": 16,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2022-11-20T03:34:30Z",
            "beginTime": "2023-04-03T20:39:08Z",
            "endTime": null,
            "simulationType": "ONE_DIMENSION_BP",
            "dt": 675,
            "v": 1231,
            "k0": 4.5,
            "kparKper": 0.08,
            "mu": 0.7,
            "finished": false
        },
        {
            "uuid": "ebbd061d-9170-4adc-a80f-b566fe463228",
            "name": "Simulation Cyperaceae",
            "billionsOfSimulations": 94,
            "billionsOfSimulationsLeft": 45,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-01-21T11:37:43Z",
            "beginTime": null,
            "endTime": null,
            "simulationType": "ONE_DIMENSION_BP",
            "dt": 319,
            "v": 246,
            "k0": 1.1,
            "kparKper": 0.09,
            "mu": 0.0,
            "finished": false
        },
        {
            "uuid": "5df3c524-81f6-4091-a43f-78e7a5f7dcfe",
            "name": "Simulation Capparaceae",
            "billionsOfSimulations": 31,
            "billionsOfSimulationsLeft": 31,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-03-05T05:54:44Z",
            "beginTime": null,
            "endTime": null,
            "simulationType": "ONE_DIMENSION_FP",
            "dt": 422,
            "v": 1349,
            "k0": 7.7,
            "kparKper": 0.09,
            "mu": 0.0,
            "finished": false
        },
        {
            "uuid": "ee6fdb94-4347-4373-a67c-34a3033ecd6b",
            "name": "Simulation Solanaceae",
            "billionsOfSimulations": 97,
            "billionsOfSimulationsLeft": 10,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2022-10-28T09:50:25Z",
            "beginTime": null,
            "endTime": null,
            "simulationType": "TWO_DIMENSION_FT",
            "dt": 901,
            "v": 1364,
            "k0": 2.0,
            "kparKper": 0.03,
            "mu": 0.4,
            "finished": false
        },
        {
            "uuid": "dc6bef7a-559a-4a8e-b724-3294b736e289",
            "name": "Simulation Hydrophyllaceae",
            "billionsOfSimulations": 50,
            "billionsOfSimulationsLeft": 10,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-03-08T18:28:08Z",
            "beginTime": "2023-03-23T01:11:05Z",
            "endTime": "2023-05-09T21:45:36Z",
            "simulationType": "TWO_DIMENSION_BP",
            "dt": 523,
            "v": 1214,
            "k0": 3.2,
            "kparKper": 0.06,
            "mu": 0.5,
            "finished": true
        },
        {
            "uuid": "3a8f309f-6565-4470-8614-5c19d8b537b9",
            "name": "Simulation Liliaceae",
            "billionsOfSimulations": 36,
            "billionsOfSimulationsLeft": 9,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-01-02T07:13:24Z",
            "beginTime": "2023-03-24T17:01:00Z",
            "endTime": "2023-05-09T13:39:05Z",
            "simulationType": "ONE_DIMENSION_BP",
            "dt": 820,
            "v": 283,
            "k0": 6.6,
            "kparKper": 0.06,
            "mu": 0.9,
            "finished": true
        },
        {
            "uuid": "b8cbde28-83be-4a0d-9598-09e2d8c1928f",
            "name": "Simulation Malvaceae",
            "billionsOfSimulations": 8,
            "billionsOfSimulationsLeft": 8,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2022-11-23T15:14:08Z",
            "beginTime": "2023-04-01T12:41:52Z",
            "endTime": null,
            "simulationType": "ONE_DIMENSION_FP",
            "dt": 242,
            "v": 419,
            "k0": 2.2,
            "kparKper": 0.06,
            "mu": 0.4,
            "finished": false
        },
        {
            "uuid": "511e3783-1474-484d-afc4-648f5ce65d12",
            "name": "Simulation Rubiaceae",
            "billionsOfSimulations": 30,
            "billionsOfSimulationsLeft": 30,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2022-11-24T03:00:43Z",
            "beginTime": "2023-03-29T04:32:35Z",
            "endTime": "2023-04-27T15:54:21Z",
            "simulationType": "ONE_DIMENSION_FP",
            "dt": 479,
            "v": 590,
            "k0": 7.9,
            "kparKper": 0.07,
            "mu": 0.1,
            "finished": true
        },
        {
            "uuid": "0022d42d-f03d-47ce-8c90-56706539a695",
            "name": "Simulation Rosaceae",
            "billionsOfSimulations": 96,
            "billionsOfSimulationsLeft": 68,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2022-12-21T23:55:17Z",
            "beginTime": "2023-03-17T16:59:13Z",
            "endTime": null,
            "simulationType": "ONE_DIMENSION_FP",
            "dt": 949,
            "v": 322,
            "k0": 8.3,
            "kparKper": 0.01,
            "mu": 0.4,
            "finished": false
        },
        {
            "uuid": "8565fecd-002c-4dd1-a92b-3b90639acae0",
            "name": "Simulation Urticaceae",
            "billionsOfSimulations": 99,
            "billionsOfSimulationsLeft": 97,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-01-10T07:17:14Z",
            "beginTime": null,
            "endTime": null,
            "simulationType": "TWO_DIMENSION_FP",
            "dt": 456,
            "v": 1093,
            "k0": 1.6,
            "kparKper": 0.09,
            "mu": 0.1,
            "finished": false
        },
        {
            "uuid": "7f029f63-9400-4ee8-923a-4e9a02c4d5e1",
            "name": "Simulation Poaceae",
            "billionsOfSimulations": 95,
            "billionsOfSimulationsLeft": 70,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2022-12-29T01:26:19Z",
            "beginTime": "2023-03-31T17:42:45Z",
            "endTime": "2023-04-23T03:34:27Z",
            "simulationType": "ONE_DIMENSION_FP",
            "dt": 855,
            "v": 756,
            "k0": 7.1,
            "kparKper": 0.1,
            "mu": 0.3,
            "finished": true
        },
        {
            "uuid": "85a22c48-a009-4ef5-a0a5-d1cce582565f",
            "name": "Simulation Pedaliaceae",
            "billionsOfSimulations": 82,
            "billionsOfSimulationsLeft": 80,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-02-07T05:05:17Z",
            "beginTime": "2023-03-13T04:19:03Z",
            "endTime": null,
            "simulationType": "TWO_DIMENSION_FT",
            "dt": 697,
            "v": 961,
            "k0": 7.8,
            "kparKper": 0.08,
            "mu": 0.4,
            "finished": false
        },
        {
            "uuid": "9e102216-0e43-4210-ab31-9352329135d6",
            "name": "Simulation Rosaceae",
            "billionsOfSimulations": 49,
            "billionsOfSimulationsLeft": 34,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-01-03T14:08:09Z",
            "beginTime": null,
            "endTime": null,
            "simulationType": "TWO_DIMENSION_FP",
            "dt": 164,
            "v": 1448,
            "k0": 2.1,
            "kparKper": 0.02,
            "mu": 1.0,
            "finished": false
        },
        {
            "uuid": "fb7a07fa-247b-47b3-ae65-5a22f80a1876",
            "name": "Simulation Chenopodiaceae",
            "billionsOfSimulations": 76,
            "billionsOfSimulationsLeft": 21,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2022-11-28T08:07:08Z",
            "beginTime": null,
            "endTime": null,
            "simulationType": "TWO_DIMENSION_FT",
            "dt": 289,
            "v": 1221,
            "k0": 4.9,
            "kparKper": 0.02,
            "mu": 0.1,
            "finished": false
        },
        {
            "uuid": "ba5e42e5-d76c-43e4-b89c-bf1811ba0783",
            "name": "Simulation Apiaceae",
            "billionsOfSimulations": 76,
            "billionsOfSimulationsLeft": 8,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-02-19T04:05:23Z",
            "beginTime": "2023-03-20T11:50:02Z",
            "endTime": "2023-05-05T07:20:45Z",
            "simulationType": "TWO_DIMENSION_FP",
            "dt": 270,
            "v": 412,
            "k0": 6.9,
            "kparKper": 0.02,
            "mu": 0.8,
            "finished": true
        },
        {
            "uuid": "8f435720-5c66-4fd6-ad13-7d813ea92a8b",
            "name": "Simulation Rosaceae",
            "billionsOfSimulations": 89,
            "billionsOfSimulationsLeft": 43,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-02-04T12:52:01Z",
            "beginTime": "2023-03-23T20:52:53Z",
            "endTime": null,
            "simulationType": "TWO_DIMENSION_FP",
            "dt": 825,
            "v": 107,
            "k0": 5.3,
            "kparKper": 0.01,
            "mu": 0.3,
            "finished": false
        },
        {
            "uuid": "9f81d136-00bb-4da8-b082-90f7f98bcf24",
            "name": "Simulation Amblystegiaceae",
            "billionsOfSimulations": 55,
            "billionsOfSimulationsLeft": 55,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-02-20T18:26:20Z",
            "beginTime": "2023-03-23T08:37:10Z",
            "endTime": null,
            "simulationType": "TWO_DIMENSION_BP",
            "dt": 185,
            "v": 230,
            "k0": 5.5,
            "kparKper": 0.02,
            "mu": 0.6,
            "finished": false
        },
        {
            "uuid": "d9ca3f29-9765-4d96-ac64-f39e5df79268",
            "name": "Simulation Violaceae",
            "billionsOfSimulations": 24,
            "billionsOfSimulationsLeft": 24,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2022-12-07T08:15:54Z",
            "beginTime": "2023-03-14T03:54:07Z",
            "endTime": null,
            "simulationType": "TWO_DIMENSION_BP",
            "dt": 547,
            "v": 330,
            "k0": 5.2,
            "kparKper": 0.09,
            "mu": 0.4,
            "finished": false
        },
        {
            "uuid": "918fe4ca-c90a-4aa8-9da6-bd40e01b6fc5",
            "name": "Simulation Polygonaceae",
            "billionsOfSimulations": 47,
            "billionsOfSimulationsLeft": 13,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-02-08T18:29:38Z",
            "beginTime": "2023-04-10T08:02:01Z",
            "endTime": null,
            "simulationType": "ONE_DIMENSION_BP",
            "dt": 41,
            "v": 377,
            "k0": 8.9,
            "kparKper": 0.05,
            "mu": 0.7,
            "finished": false
        },
        {
            "uuid": "768f5b1b-7146-4fd7-a491-cfa3c32b7a1a",
            "name": "Simulation Asteraceae",
            "billionsOfSimulations": 50,
            "billionsOfSimulationsLeft": 50,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2022-11-29T00:13:28Z",
            "beginTime": "2023-03-20T18:39:58Z",
            "endTime": "2023-04-18T21:13:47Z",
            "simulationType": "ONE_DIMENSION_FP",
            "dt": 305,
            "v": 846,
            "k0": 1.1,
            "kparKper": 0.03,
            "mu": 0.2,
            "finished": true
        },
        {
            "uuid": "7e6e64fd-94df-49f5-a980-29be074cd896",
            "name": "Simulation Cyperaceae",
            "billionsOfSimulations": 82,
            "billionsOfSimulationsLeft": 31,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2022-11-16T06:22:11Z",
            "beginTime": null,
            "endTime": null,
            "simulationType": "ONE_DIMENSION_FP",
            "dt": 775,
            "v": 310,
            "k0": 2.2,
            "kparKper": 0.08,
            "mu": 0.8,
            "finished": false
        },
        {
            "uuid": "329187fa-7c2f-4169-af1a-0ece7d128354",
            "name": "Simulation Fjelljord",
            "billionsOfSimulations": 88,
            "billionsOfSimulationsLeft": 63,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-02-22T23:37:41Z",
            "beginTime": "2023-03-17T23:51:41Z",
            "endTime": "2023-04-26T09:10:47Z",
            "simulationType": "TWO_DIMENSION_FP",
            "dt": 685,
            "v": 1424,
            "k0": 5.0,
            "kparKper": 0.06,
            "mu": 0.8,
            "finished": false
        },
        {
            "uuid": "076f9274-1e30-4b3a-b6af-4be8e792d605",
            "name": "Simulation Liliaceae",
            "billionsOfSimulations": 15,
            "billionsOfSimulationsLeft": 15,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2022-11-30T13:45:13Z",
            "beginTime": "2023-03-18T01:54:15Z",
            "endTime": null,
            "simulationType": "TWO_DIMENSION_FP",
            "dt": 357,
            "v": 1264,
            "k0": 5.3,
            "kparKper": 0.06,
            "mu": 0.8,
            "finished": false
        },
        {
            "uuid": "19c29f96-4ba2-4676-a0e7-4d46794f7fba",
            "name": "Simulation Brassicaceae",
            "billionsOfSimulations": 61,
            "billionsOfSimulationsLeft": 30,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2022-10-24T12:36:03Z",
            "beginTime": "2023-03-14T08:40:50Z",
            "endTime": null,
            "simulationType": "TWO_DIMENSION_BP",
            "dt": 774,
            "v": 1068,
            "k0": 7.7,
            "kparKper": 0.06,
            "mu": 0.5,
            "finished": false
        },
        {
            "uuid": "7869056a-6eff-4119-bcb5-365a61149a37",
            "name": "Simulation Urticaceae",
            "billionsOfSimulations": 42,
            "billionsOfSimulationsLeft": 42,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2022-10-26T05:54:43Z",
            "beginTime": "2023-03-13T11:01:07Z",
            "endTime": null,
            "simulationType": "ONE_DIMENSION_BP",
            "dt": 193,
            "v": 1286,
            "k0": 6.3,
            "kparKper": 0.06,
            "mu": 0.8,
            "finished": false
        },
        {
            "uuid": "9b706e35-7891-4a04-ad55-173fcd031de6",
            "name": "Simulation Acarosporaceae",
            "billionsOfSimulations": 30,
            "billionsOfSimulationsLeft": 13,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2022-11-17T19:02:50Z",
            "beginTime": "2023-03-15T15:17:01Z",
            "endTime": null,
            "simulationType": "TWO_DIMENSION_BP",
            "dt": 503,
            "v": 621,
            "k0": 3.8,
            "kparKper": 0.04,
            "mu": 0.0,
            "finished": false
        },
        {
            "uuid": "cbbab7ce-f23f-4a95-a0ad-f970f9705a7a",
            "name": "Simulation Malvaceae",
            "billionsOfSimulations": 90,
            "billionsOfSimulationsLeft": 87,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-02-11T10:52:39Z",
            "beginTime": null,
            "endTime": null,
            "simulationType": "TWO_DIMENSION_FT",
            "dt": 483,
            "v": 841,
            "k0": 6.5,
            "kparKper": 0.07,
            "mu": 0.5,
            "finished": false
        },
        {
            "uuid": "dc06f034-74f2-4d53-9ec4-0a957eb6b079",
            "name": "Simulation Valerianaceae",
            "billionsOfSimulations": 11,
            "billionsOfSimulationsLeft": 11,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2022-11-11T01:18:37Z",
            "beginTime": null,
            "endTime": null,
            "simulationType": "ONE_DIMENSION_BP",
            "dt": 526,
            "v": 939,
            "k0": 8.9,
            "kparKper": 0.09,
            "mu": 0.4,
            "finished": false
        },
        {
            "uuid": "bf449dc6-b3c8-4efd-aef1-c85549623300",
            "name": "Simulation Rosaceae",
            "billionsOfSimulations": 29,
            "billionsOfSimulationsLeft": 20,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2022-12-16T22:15:47Z",
            "beginTime": "2023-04-09T00:34:04Z",
            "endTime": null,
            "simulationType": "TWO_DIMENSION_FT",
            "dt": 365,
            "v": 979,
            "k0": 5.6,
            "kparKper": 0.05,
            "mu": 0.0,
            "finished": false
        },
        {
            "uuid": "68e73c35-a5f3-4e7d-95c1-440dacf9b45f",
            "name": "Simulation Hymenophyllaceae",
            "billionsOfSimulations": 74,
            "billionsOfSimulationsLeft": 74,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2022-11-13T18:32:25Z",
            "beginTime": null,
            "endTime": null,
            "simulationType": "ONE_DIMENSION_BP",
            "dt": 883,
            "v": 1367,
            "k0": 6.2,
            "kparKper": 0.01,
            "mu": 0.8,
            "finished": false
        },
        {
            "uuid": "53f6e760-e947-461e-89c7-4f687e2a8d4a",
            "name": "Simulation Teloschistaceae",
            "billionsOfSimulations": 81,
            "billionsOfSimulationsLeft": 0,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-02-23T16:01:10Z",
            "beginTime": "2023-04-05T14:05:03Z",
            "endTime": "2023-05-02T18:30:10Z",
            "simulationType": "ONE_DIMENSION_FP",
            "dt": 28,
            "v": 465,
            "k0": 1.7,
            "kparKper": 0.08,
            "mu": 0.6,
            "finished": true
        },
        {
            "uuid": "a984e0eb-76a1-4a8f-8467-db9bbd759b94",
            "name": "Simulation Ericaceae",
            "billionsOfSimulations": 84,
            "billionsOfSimulationsLeft": 40,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-01-04T06:55:04Z",
            "beginTime": "2023-04-07T03:16:01Z",
            "endTime": "2023-04-26T23:51:22Z",
            "simulationType": "ONE_DIMENSION_BP",
            "dt": 176,
            "v": 101,
            "k0": 7.8,
            "kparKper": 0.08,
            "mu": 0.2,
            "finished": true
        },
        {
            "uuid": "bbf933c9-e163-4af3-875f-8dbe847cc890",
            "name": "Simulation Poaceae",
            "billionsOfSimulations": 28,
            "billionsOfSimulationsLeft": 28,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2022-11-23T06:45:44Z",
            "beginTime": null,
            "endTime": null,
            "simulationType": "TWO_DIMENSION_FT",
            "dt": 232,
            "v": 185,
            "k0": 1.2,
            "kparKper": 0.06,
            "mu": 0.8,
            "finished": false
        },
        {
            "uuid": "ffb454b2-3fe6-4400-9047-32717c1c165a",
            "name": "Simulation Rosaceae",
            "billionsOfSimulations": 84,
            "billionsOfSimulationsLeft": 6,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-01-24T17:03:14Z",
            "beginTime": null,
            "endTime": null,
            "simulationType": "TWO_DIMENSION_BP",
            "dt": 231,
            "v": 115,
            "k0": 7.4,
            "kparKper": 0.05,
            "mu": 0.7,
            "finished": false
        },
        {
            "uuid": "6f9b4fcf-1dd0-4e71-8be1-59bd95cedc36",
            "name": "Simulation Solanaceae",
            "billionsOfSimulations": 38,
            "billionsOfSimulationsLeft": 38,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-02-17T02:16:44Z",
            "beginTime": "2023-03-31T10:02:07Z",
            "endTime": "2023-05-09T01:31:46Z",
            "simulationType": "ONE_DIMENSION_BP",
            "dt": 458,
            "v": 185,
            "k0": 8.9,
            "kparKper": 0.08,
            "mu": 0.9,
            "finished": true
        },
        {
            "uuid": "a9bb88d8-d2c6-41ce-b374-5060da86120e",
            "name": "Simulation Solanaceae",
            "billionsOfSimulations": 21,
            "billionsOfSimulationsLeft": 21,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-03-03T09:11:08Z",
            "beginTime": "2023-04-10T22:24:08Z",
            "endTime": null,
            "simulationType": "ONE_DIMENSION_BP",
            "dt": 746,
            "v": 1341,
            "k0": 7.9,
            "kparKper": 0.02,
            "mu": 0.6,
            "finished": false
        },
        {
            "uuid": "4f90ac33-e683-457e-9ede-7f46e94c8efb",
            "name": "Simulation Brassicaceae",
            "billionsOfSimulations": 15,
            "billionsOfSimulationsLeft": 0,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-02-02T01:37:03Z",
            "beginTime": "2023-04-02T07:50:50Z",
            "endTime": "2023-04-14T14:16:47Z",
            "simulationType": "ONE_DIMENSION_BP",
            "dt": 453,
            "v": 103,
            "k0": 7.6,
            "kparKper": 0.06,
            "mu": 0.6,
            "finished": true
        },
        {
            "uuid": "test",
            "name": "Simulation Apiaceae",
            "billionsOfSimulations": 58,
            "billionsOfSimulationsLeft": 32,
            "resultMap": {},
            "nodeSimulationApiModelList": [],
            "createTime": "2023-01-24T10:18:09Z",
            "beginTime": null,
            "endTime": null,
            "simulationType": "ONE_DIMENSION_BP",
            "dt": 261,
            "v": 530,
            "k0": 8.4,
            "kparKper": 0.07,
            "mu": 0.9,
            "finished": false
        }
    ],
    "nodes": [
        {
            "gpu": "GTX_1080",
            "isActive": true,
            "isComputing": true,
            "lastUpdatedTime": "2023-01-01T11:59:17.171"
        },
        {
            "gpu": "GTX_1070",
            "isActive": true,
            "isComputing": true,
            "lastUpdatedTime": "2023-01-08T11:59:17.171"
        },
        {
            "gpu": "RTX_2060",
            "isActive": false,
            "isComputing": true,
            "lastUpdatedTime": "2023-01-10T11:59:17.171"
        },
        {
            "gpu": "RTX_2080_TI",
            "isActive": true,
            "isComputing": false,
            "lastUpdatedTime": "2023-01-12T11:59:17.171"
        },
        {
            "gpu": "GTX_1660_TI",
            "isActive": false,
            "isComputing": false,
            "lastUpdatedTime": "2023-01-15T11:59:17.171"
        },
        {
            "gpu": "GTX_1080_TI",
            "isActive": false,
            "isComputing": true,
            "lastUpdatedTime": "2023-01-22T18:59:17.171"
        },
        {
            "gpu": "UKNOWN",
            "isActive": true,
            "isComputing": true,
            "lastUpdatedTime": "2023-01-25T13:59:17.171"
        }
    ],
    "graph": [
        "0.10",
        "1.00000000000000E+003",
        "1.70343196708619E-026",
        "0.20",
        "1.00100000000000E+003",
        "2.43652171828214E-026",
        "0.30",
        "9.99000000000000E+002",
        "3.23660963295749E-026",
        "0.40",
        "1.00100000000000E+003",
        "3.33294233638614E-026",
        "0.50",
        "1.00000000000000E+003",
        "3.44749310653923E-026",
        "0.60",
        "1.00000000000000E+003",
        "3.37166460338093E-026",
        "0.70",
        "9.99000000000000E+002",
        "3.45049183458393E-026",
        "0.80",
        "1.00000000000000E+003",
        "3.09022916011713E-026",
        "0.90",
        "1.00000000000000E+003",
        "3.06170390142281E-026",
        "1.00",
        "1.00000000000000E+003",
        "2.94628671381817E-026",
        "1.10",
        "1.00000000000000E+003",
        "2.55870752112606E-026",
        "1.20",
        "1.00100000000000E+003",
        "2.48551706343514E-026",
        "1.30",
        "9.99000000000000E+002",
        "2.34757291661561E-026",
        "1.40",
        "1.00000000000000E+003",
        "2.29180114166207E-026",
        "1.50",
        "1.00100000000000E+003",
        "2.08212862982266E-026",
        "1.60",
        "1.00000000000000E+003",
        "2.01201790281064E-026",
        "1.70",
        "9.99000000000000E+002",
        "1.92179723186964E-026",
        "1.80",
        "1.00100000000000E+003",
        "1.76637476355937E-026",
        "1.90",
        "1.00000000000000E+003",
        "1.73257723397485E-026",
        "2.00",
        "9.99000000000000E+002",
        "1.55772227446483E-026",
        "2.10",
        "1.00000000000000E+003",
        "1.50233425119666E-026",
        "2.20",
        "1.00000000000000E+003",
        "1.48065792891739E-026",
        "2.30",
        "1.00100000000000E+003",
        "1.34441403316672E-026",
        "2.40",
        "1.00000000000000E+003",
        "1.23946132037675E-026",
        "2.50",
        "9.99000000000000E+002",
        "1.22269746590696E-026",
        "2.60",
        "1.00100000000000E+003",
        "1.13391646461802E-026",
        "2.70",
        "9.99000000000000E+002",
        "1.06592021045890E-026",
        "2.80",
        "1.00000000000000E+003",
        "1.04852475821751E-026",
        "2.90",
        "1.00100000000000E+003",
        "9.81270255352940E-027",
        "3.00",
        "1.00000000000000E+003",
        "9.51642002230266E-027",
        "3.10",
        "9.99000000000000E+002",
        "8.96163303855273E-027",
        "3.20",
        "1.00100000000000E+003",
        "8.65033891975636E-027",
        "3.30",
        "1.00000000000000E+003",
        "8.19863791695593E-027",
        "3.40",
        "1.00000000000000E+003",
        "7.65804237412539E-027",
        "3.50",
        "1.00000000000000E+003",
        "7.57712085625756E-027",
        "3.60",
        "9.99000000000000E+002",
        "7.07263537483522E-027",
        "3.70",
        "1.00000000000000E+003",
        "6.90237729629414E-027",
        "3.80",
        "1.00100000000000E+003",
        "6.51322987223605E-027",
        "3.90",
        "9.99000000000000E+002",
        "6.25581843701125E-027",
        "4.00",
        "1.00100000000000E+003",
        "6.03874729854000E-027",
        "4.10",
        "9.99000000000000E+002",
        "5.73255456314165E-027",
        "4.20",
        "1.00000000000000E+003",
        "5.50308312403610E-027",
        "4.30",
        "1.00000000000000E+003",
        "5.33430288083892E-027",
        "4.40",
        "1.00000000000000E+003",
        "5.05935714630038E-027",
        "4.50",
        "1.00100000000000E+003",
        "4.80951675991016E-027",
        "4.60",
        "9.99000000000000E+002",
        "4.76563709107652E-027",
        "4.70",
        "9.99000000000000E+002",
        "4.57401259087764E-027",
        "4.80",
        "1.00100000000000E+003",
        "4.36652068761723E-027",
        "4.90",
        "9.99000000000000E+002",
        "4.20746738261758E-027",
        "5.00",
        "1.00100000000000E+003",
        "4.00380693028406E-027",
        "5.10",
        "1.00000000000000E+003",
        "3.95476977731613E-027",
        "5.20",
        "1.00000000000000E+003",
        "3.78861547296477E-027",
        "5.30",
        "9.98000000000000E+002",
        "3.65276668367419E-027",
        "5.40",
        "1.00000000000000E+003",
        "3.57352318238077E-027",
        "5.50",
        "1.00000000000000E+003",
        "3.37157271709755E-027",
        "5.60",
        "1.00000000000000E+003",
        "3.31826284713388E-027",
        "5.70",
        "1.00100000000000E+003",
        "3.15206023728878E-027",
        "5.80",
        "1.00000000000000E+003",
        "3.10078386456877E-027",
        "5.90",
        "9.99000000000000E+002",
        "3.01557414805651E-027",
        "6.00",
        "1.00000000000000E+003",
        "2.91771776803385E-027",
        "6.10",
        "1.00100000000000E+003",
        "2.81608571859361E-027",
        "6.20",
        "1.00000000000000E+003",
        "2.74026424699479E-027",
        "6.30",
        "9.99000000000000E+002",
        "2.58764813667254E-027",
        "6.40",
        "1.00100000000000E+003",
        "2.54079153034450E-027",
        "6.50",
        "9.99000000000000E+002",
        "2.52493672324111E-027",
        "6.60",
        "1.00100000000000E+003",
        "2.40261616180454E-027",
        "6.70",
        "1.00000000000000E+003",
        "2.30158737332525E-027",
        "6.80",
        "1.00000000000000E+003",
        "2.25539248142491E-027",
        "6.90",
        "1.00000000000000E+003",
        "2.20955207270469E-027",
        "7.00",
        "1.00000000000000E+003",
        "2.16114480514933E-027",
        "7.10",
        "1.00000000000000E+003",
        "2.05434515586825E-027",
        "7.20",
        "9.99000000000000E+002",
        "2.03575103423581E-027",
        "7.30",
        "1.00000000000000E+003",
        "2.03346167522406E-027",
        "7.40",
        "1.00100000000000E+003",
        "1.92004563909978E-027",
        "7.50",
        "1.00000000000000E+003",
        "1.87646490066663E-027",
        "7.60",
        "9.99000000000000E+002",
        "1.83490333664347E-027",
        "7.70",
        "1.00100000000000E+003",
        "1.76978936943751E-027",
        "7.80",
        "1.00000000000000E+003",
        "1.73856591177680E-027",
        "7.90",
        "1.00000000000000E+003",
        "1.68723739828499E-027",
        "8.00",
        "1.00000000000000E+003",
        "1.61117605221275E-027",
        "8.10",
        "9.99000000000000E+002",
        "1.60290521503437E-027",
        "8.20",
        "1.00100000000000E+003",
        "1.55018566630395E-027",
        "8.30",
        "1.00000000000000E+003",
        "1.52800140419463E-027",
        "8.40",
        "9.99000000000000E+002",
        "1.48090609833356E-027",
        "8.50",
        "1.00000000000000E+003",
        "1.41222185231947E-027",
        "8.60",
        "1.00100000000000E+003",
        "1.41394683587945E-027",
        "8.70",
        "9.99000000000000E+002",
        "1.39422665615317E-027",
        "8.80",
        "1.00100000000000E+003",
        "1.33374902974884E-027",
        "8.90",
        "1.00000000000000E+003",
        "1.31819870682505E-027",
        "9.00",
        "1.00000000000000E+003",
        "1.28779573209330E-027",
        "9.10",
        "1.00000000000000E+003",
        "1.26311593662874E-027",
        "9.20",
        "9.99000000000000E+002",
        "1.22665806331729E-027",
        "9.30",
        "1.00100000000000E+003",
        "1.19739989874333E-027",
        "9.40",
        "9.99000000000000E+002",
        "1.16748596796375E-027",
        "9.50",
        "1.00000000000000E+003",
        "1.13890166091553E-027",
        "9.60",
        "1.00000000000000E+003",
        "1.11265531670970E-027",
        "9.70",
        "1.00000000000000E+003",
        "1.10225855585294E-027",
        "9.80",
        "1.00000000000000E+003",
        "1.07482020295948E-027",
        "9.90",
        "1.00100000000000E+003",
        "1.05294736822801E-027",
        "10.00",
        "1.00000000000000E+003",
        "1.01877255555760E-027",
        "10.10",
        "9.99000000000000E+002",
        "9.95175370876068E-028",
        "10.20",
        "1.00100000000000E+003",
        "9.77338810444401E-028",
        "10.30",
        "1.00000000000000E+003",
        "9.54448735048249E-028",
        "10.40",
        "1.00000000000000E+003",
        "9.43447469489562E-028",
        "10.50",
        "1.00000000000000E+003",
        "9.16474370104617E-028",
        "10.60",
        "9.99000000000000E+002",
        "9.03774301053870E-028",
        "10.70",
        "1.00000000000000E+003",
        "8.74964800094030E-028",
        "10.80",
        "9.99000000000000E+002",
        "8.68812263846353E-028",
        "10.90",
        "1.00000000000000E+003",
        "8.41229332891956E-028",
        "11.00",
        "1.00000000000000E+003",
        "8.34588579324521E-028",
        "11.10",
        "1.00000000000000E+003",
        "8.08551927237163E-028",
        "11.20",
        "1.00000000000000E+003",
        "7.91863137936180E-028",
        "11.30",
        "1.00000000000000E+003",
        "7.81093698487254E-028",
        "11.40",
        "1.00000000000000E+003",
        "7.66487870413296E-028",
        "11.50",
        "1.00100000000000E+003",
        "7.52324889147717E-028",
        "11.60",
        "9.99000000000000E+002",
        "7.46776559251627E-028",
        "11.70",
        "1.00000000000000E+003",
        "7.24282418482789E-028",
        "11.80",
        "1.00000000000000E+003",
        "7.14095950042093E-028",
        "11.90",
        "1.00100000000000E+003",
        "6.98490630313741E-028",
        "12.00",
        "9.99000000000000E+002",
        "6.81632035678559E-028",
        "12.10",
        "1.00100000000000E+003",
        "6.80277887749949E-028",
        "12.20",
        "1.00000000000000E+003",
        "6.54094747942638E-028",
        "12.30",
        "9.99000000000000E+002",
        "6.48418901374659E-028",
        "12.40",
        "1.00100000000000E+003",
        "6.30219493773732E-028",
        "12.50",
        "9.99000000000000E+002",
        "6.26430455371960E-028",
        "12.60",
        "1.00100000000000E+003",
        "6.11579682338571E-028",
        "12.70",
        "1.00000000000000E+003",
        "6.01479162341894E-028",
        "12.80",
        "9.99000000000000E+002",
        "5.91420488243686E-028",
        "12.90",
        "1.00100000000000E+003",
        "5.76422623546629E-028",
        "13.00",
        "9.99000000000000E+002",
        "5.70586599204661E-028",
        "13.10",
        "1.00000000000000E+003",
        "5.62950232705152E-028",
        "13.20",
        "1.00000000000000E+003",
        "5.46372169665484E-028",
        "13.30",
        "1.00000000000000E+003",
        "5.39862399734988E-028",
        "13.40",
        "1.00000000000000E+003",
        "5.29882637118477E-028",
        "13.50",
        "9.98000000000000E+002",
        "5.23247510182334E-028",
        "13.60",
        "1.00100000000000E+003",
        "5.13410224581142E-028",
        "13.70",
        "9.99000000000000E+002",
        "5.04021879298733E-028",
        "13.80",
        "1.00000000000000E+003",
        "5.01490906020825E-028",
        "13.90",
        "1.00000000000000E+003",
        "4.87585951855110E-028",
        "14.00",
        "1.00000000000000E+003",
        "4.83015546262421E-028",
        "14.10",
        "1.00100000000000E+003",
        "4.74103055695944E-028",
        "14.20",
        "1.00000000000000E+003",
        "4.63283064938440E-028",
        "14.30",
        "9.99000000000000E+002",
        "4.60911012295667E-028",
        "14.40",
        "1.00000000000000E+003",
        "4.49263521716018E-028",
        "14.50",
        "1.00100000000000E+003",
        "4.47301372398308E-028",
        "14.60",
        "1.00000000000000E+003",
        "4.37493449573371E-028",
        "14.70",
        "1.00000000000000E+003",
        "4.32023500065770E-028",
        "14.80",
        "1.00000000000000E+003",
        "4.19760762670339E-028",
        "14.90",
        "9.99000000000000E+002",
        "4.14889356429068E-028",
        "15.00",
        "1.00100000000000E+003",
        "4.10639663909229E-028",
        "15.10",
        "9.99000000000000E+002",
        "4.06961717115381E-028",
        "15.20",
        "1.00000000000000E+003",
        "4.02045169031098E-028",
        "15.30",
        "9.99000000000000E+002",
        "3.93471295050465E-028",
        "15.40",
        "1.00000000000000E+003",
        "3.84233847866354E-028",
        "15.50",
        "1.00000000000000E+003",
        "3.78108301047568E-028",
        "15.60",
        "1.00000000000000E+003",
        "3.72092669072827E-028",
        "15.70",
        "1.00100000000000E+003",
        "3.68071193792462E-028",
        "15.80",
        "1.00000000000000E+003",
        "3.65077506540030E-028",
        "15.90",
        "9.99000000000000E+002",
        "3.57686943893606E-028",
        "16.00",
        "1.00100000000000E+003",
        "3.53757148111634E-028",
        "16.10",
        "9.99000000000000E+002",
        "3.49070348763289E-028",
        "16.20",
        "1.00100000000000E+003",
        "3.41447998692457E-028",
        "16.30",
        "1.00000000000000E+003",
        "3.38550955616052E-028",
        "16.40",
        "9.99000000000000E+002",
        "3.34431131247907E-028",
        "16.50",
        "1.00000000000000E+003",
        "3.29082385416514E-028",
        "16.60",
        "1.00000000000000E+003",
        "3.26598306329364E-028",
        "16.70",
        "1.00000000000000E+003",
        "3.21088346536141E-028",
        "16.80",
        "1.00100000000000E+003",
        "3.15365638242948E-028",
        "16.90",
        "1.00000000000000E+003",
        "3.10291082073204E-028",
        "17.00",
        "9.99000000000000E+002",
        "3.07030331704854E-028",
        "17.10",
        "1.00100000000000E+003",
        "3.02786389057855E-028",
        "17.20",
        "9.99000000000000E+002",
        "2.97644259473002E-028",
        "17.30",
        "1.00100000000000E+003",
        "2.93656724046918E-028",
        "17.40",
        "9.99000000000000E+002",
        "2.89446244135443E-028",
        "17.50",
        "1.00000000000000E+003",
        "2.86829204919494E-028",
        "17.60",
        "9.99000000000000E+002",
        "2.82722618960857E-028",
        "17.70",
        "1.00100000000000E+003",
        "2.79633364732670E-028",
        "17.80",
        "1.00000000000000E+003",
        "2.72645217372174E-028",
        "17.90",
        "1.00000000000000E+003",
        "2.71608554309578E-028",
        "18.00",
        "1.00000000000000E+003",
        "2.66979920591852E-028",
        "18.10",
        "1.00000000000000E+003",
        "2.64494887798331E-028",
        "18.20",
        "9.99000000000000E+002",
        "2.61840628425587E-028",
        "18.30",
        "1.00000000000000E+003",
        "2.58234061079054E-028",
        "18.40",
        "1.00000000000000E+003",
        "2.55192252686380E-028",
        "18.50",
        "1.00000000000000E+003",
        "2.50515655469627E-028",
        "18.60",
        "1.00000000000000E+003",
        "2.48310148043951E-028",
        "18.70",
        "1.00000000000000E+003",
        "2.45120993788087E-028",
        "18.80",
        "1.00000000000000E+003",
        "2.42102661327828E-028",
        "18.90",
        "1.00000000000000E+003",
        "2.37870068151993E-028",
        "19.00",
        "1.00000000000000E+003",
        "2.36416539666081E-028",
        "19.10",
        "1.00000000000000E+003",
        "2.33881822242087E-028",
        "19.20",
        "1.00000000000000E+003",
        "2.29734582686754E-028",
        "19.30",
        "1.00000000000000E+003",
        "2.26431793468708E-028",
        "19.40",
        "1.00000000000000E+003",
        "2.24263093479930E-028",
        "19.50",
        "1.00000000000000E+003",
        "2.22139774661453E-028",
        "19.60",
        "1.00000000000000E+003",
        "2.18814620337678E-028",
        "19.70",
        "1.00000000000000E+003",
        "2.16400884675561E-028",
        "19.80",
        "1.00000000000000E+003",
        "2.13777970231524E-028",
        "19.90",
        "1.00000000000000E+003",
        "2.11711731682366E-028",
        "20.00",
        "1.00000000000000E+003",
        "2.08297760537842E-028",
        "20.10",
        "1.00000000000000E+003",
        "2.05036837853202E-028",
        "20.20",
        "1.00000000000000E+003",
        "2.03603559233770E-028",
        "20.30",
        "1.00000000000000E+003",
        "2.01389332009858E-028",
        "20.40",
        "1.00000000000000E+003",
        "1.99892240418868E-028",
        "20.50",
        "1.00000000000000E+003",
        "1.97368035224063E-028",
        "20.60",
        "1.00000000000000E+003",
        "1.93595369420111E-028",
        "20.70",
        "9.99000000000000E+002",
        "1.91738435203910E-028",
        "20.80",
        "1.00100000000000E+003",
        "1.88671148030681E-028",
        "20.90",
        "1.00000000000000E+003",
        "1.86553869529495E-028",
        "21.00",
        "1.00000000000000E+003",
        "1.86417673418757E-028",
        "21.10",
        "1.00000000000000E+003",
        "1.81910525154095E-028",
        "21.20",
        "9.99000000000000E+002",
        "1.80986037951394E-028",
        "21.30",
        "1.00000000000000E+003",
        "1.78842851694664E-028",
        "21.40",
        "9.99000000000000E+002",
        "1.75725044278703E-028",
        "21.50",
        "1.00000000000000E+003",
        "1.75890353502255E-028",
        "21.60",
        "1.00000000000000E+003",
        "1.73343518928999E-028",
        "21.70",
        "1.00000000000000E+003",
        "1.70843903206130E-028",
        "21.80",
        "1.00000000000000E+003",
        "1.69752150848159E-028",
        "21.90",
        "1.00100000000000E+003",
        "1.66561555924895E-028",
        "22.00",
        "1.00000000000000E+003",
        "1.65805992118745E-028",
        "22.10",
        "1.00000000000000E+003",
        "1.63702309274262E-028",
        "22.20",
        "1.00000000000000E+003",
        "1.62093012038574E-028",
        "22.30",
        "9.99000000000000E+002",
        "1.60242448472244E-028",
        "22.40",
        "1.00000000000000E+003",
        "1.57831745235455E-028",
        "22.50",
        "1.00000000000000E+003",
        "1.56946244743845E-028",
        "22.60",
        "1.00100000000000E+003",
        "1.55543191578860E-028",
        "22.70",
        "9.99000000000000E+002",
        "1.54034047615943E-028",
        "22.80",
        "1.00000000000000E+003",
        "1.51397875946796E-028",
        "22.90",
        "1.00000000000000E+003",
        "1.50068540787312E-028",
        "23.00",
        "9.99000000000000E+002",
        "1.48302804232600E-028",
        "23.10",
        "1.00000000000000E+003",
        "1.46633244024542E-028",
        "23.20",
        "1.00000000000000E+003",
        "1.46408640190005E-028",
        "23.30",
        "1.00100000000000E+003",
        "1.45039066144081E-028",
        "23.40",
        "1.00000000000000E+003",
        "1.43114057849251E-028",
        "23.50",
        "1.00000000000000E+003",
        "1.41045829234589E-028",
        "23.60",
        "9.99000000000000E+002",
        "1.39337277400147E-028",
        "23.70",
        "1.00000000000000E+003",
        "1.37974279143886E-028",
        "23.80",
        "1.00100000000000E+003",
        "1.36549427639116E-028",
        "23.90",
        "1.00000000000000E+003",
        "1.35290743013049E-028",
        "24.00",
        "9.99000000000000E+002",
        "1.33261452510387E-028",
        "24.10",
        "9.99000000000000E+002",
        "1.32575199097318E-028",
        "24.20",
        "1.00000000000000E+003",
        "1.31459065711491E-028",
        "24.30",
        "1.00000000000000E+003",
        "1.30376739665621E-028",
        "24.40",
        "1.00100000000000E+003",
        "1.28834089263970E-028",
        "24.50",
        "1.00000000000000E+003",
        "1.26683881448632E-028",
        "24.60",
        "9.98000000000000E+002",
        "1.25956176027013E-028",
        "24.70",
        "1.00000000000000E+003",
        "1.24966803403139E-028",
        "24.80",
        "1.00100000000000E+003",
        "1.23894640106645E-028",
        "24.90",
        "1.00000000000000E+003",
        "1.21907826540016E-028",
        "25.00",
        "1.00000000000000E+003",
        "1.22052789244330E-028",
        "25.10",
        "9.99000000000000E+002",
        "1.19623863911880E-028",
        "25.20",
        "1.00000000000000E+003",
        "1.19247165576668E-028",
        "25.30",
        "1.00100000000000E+003",
        "1.17310044740525E-028",
        "25.40",
        "1.00000000000000E+003",
        "1.16891686642429E-028",
        "25.50",
        "9.98000000000000E+002",
        "1.15943260842075E-028",
        "25.60",
        "1.00000000000000E+003",
        "1.13808629463593E-028",
        "25.70",
        "1.00100000000000E+003",
        "1.13296475657437E-028",
        "25.80",
        "1.00000000000000E+003",
        "1.12321869388827E-028",
        "25.90",
        "9.99000000000000E+002",
        "1.11503169351638E-028",
        "26.00",
        "1.00000000000000E+003",
        "1.09888342924270E-028",
        "26.10",
        "1.00000000000000E+003",
        "1.09201665183251E-028",
        "26.20",
        "1.00000000000000E+003",
        "1.08104996824423E-028",
        "26.30",
        "9.99000000000000E+002",
        "1.07234843247137E-028",
        "26.40",
        "1.00000000000000E+003",
        "1.05796064292010E-028",
        "26.50",
        "1.00100000000000E+003",
        "1.04992215488976E-028",
        "26.60",
        "9.99000000000000E+002",
        "1.03968922929186E-028",
        "26.70",
        "9.99000000000000E+002",
        "1.02898610163763E-028",
        "26.80",
        "1.00000000000000E+003",
        "1.02498544530475E-028",
        "26.90",
        "1.00100000000000E+003",
        "1.01574904481227E-028",
        "27.00",
        "1.00000000000000E+003",
        "1.00672643656193E-028",
        "27.10",
        "9.98000000000000E+002",
        "9.89400048588003E-029",
        "27.20",
        "1.00000000000000E+003",
        "9.87301869714144E-029",
        "27.30",
        "1.00100000000000E+003",
        "9.74650790335247E-029",
        "27.40",
        "1.00000000000000E+003",
        "9.68660583213204E-029",
        "27.50",
        "9.99000000000000E+002",
        "9.63381066723476E-029",
        "27.60",
        "1.00000000000000E+003",
        "9.47298168734475E-029",
        "27.70",
        "1.00100000000000E+003",
        "9.46282036667245E-029",
        "27.80",
        "9.99000000000000E+002",
        "9.34091216783028E-029",
        "27.90",
        "1.00000000000000E+003",
        "9.24646979050974E-029",
        "28.00",
        "1.00100000000000E+003",
        "9.16377439276281E-029",
        "28.10",
        "1.00000000000000E+003",
        "9.11218384005685E-029",
        "28.20",
        "9.99000000000000E+002",
        "9.00897483095600E-029",
        "28.30",
        "1.00000000000000E+003",
        "8.93078484586022E-029",
        "28.40",
        "1.00100000000000E+003",
        "8.84478503152551E-029",
        "28.50",
        "9.99000000000000E+002",
        "8.79825186247878E-029",
        "28.60",
        "1.00000000000000E+003",
        "8.66916525777708E-029",
        "28.70",
        "1.00000000000000E+003",
        "8.64497678759620E-029",
        "28.80",
        "1.00000000000000E+003",
        "8.50674650854051E-029",
        "28.90",
        "9.99000000000000E+002",
        "8.48025165569256E-029",
        "29.00",
        "1.00100000000000E+003",
        "8.39829582371408E-029",
        "29.10",
        "1.00000000000000E+003",
        "8.35152262493677E-029",
        "29.20",
        "9.99000000000000E+002",
        "8.27618504739348E-029",
        "29.30",
        "1.00000000000000E+003",
        "8.17403503691912E-029",
        "29.40",
        "1.00100000000000E+003",
        "8.13507524236993E-029",
        "29.50",
        "9.99000000000000E+002",
        "8.05869884951068E-029",
        "29.60",
        "9.99000000000000E+002",
        "7.98009547105717E-029",
        "29.70",
        "1.00100000000000E+003",
        "7.91623152230803E-029",
        "29.80",
        "9.99000000000000E+002",
        "7.84775522882137E-029",
        "29.90",
        "1.00000000000000E+003",
        "7.76567514916043E-029",
        "30.00",
        "1.00100000000000E+003",
        "7.71046975897401E-029",
        "30.10",
        "9.99000000000000E+002",
        "7.65521260086068E-029",
        "30.20",
        "1.00000000000000E+003",
        "7.60453893925857E-029",
        "30.30",
        "1.00100000000000E+003",
        "7.55825125498638E-029",
        "30.40",
        "9.99000000000000E+002",
        "7.47204841251746E-029",
        "30.50",
        "1.00000000000000E+003",
        "7.43592770430424E-029",
        "30.60",
        "1.00100000000000E+003",
        "7.35967249034918E-029",
        "30.70",
        "9.99000000000000E+002",
        "7.31570056125477E-029",
        "30.80",
        "9.99000000000000E+002",
        "7.24819265643676E-029",
        "30.90",
        "1.00100000000000E+003",
        "7.17084411011408E-029",
        "31.00",
        "9.99000000000000E+002",
        "7.13845839864591E-029",
        "31.10",
        "9.99000000000000E+002",
        "7.04217659502588E-029",
        "31.20",
        "1.00100000000000E+003",
        "7.00256699921325E-029",
        "31.30",
        "9.98000000000000E+002",
        "6.90552989481309E-029",
        "31.40",
        "1.00000000000000E+003",
        "6.89300544982983E-029",
        "31.50",
        "1.00100000000000E+003",
        "6.85744286053736E-029",
        "31.60",
        "9.99000000000000E+002",
        "6.79219584371958E-029",
        "31.70",
        "1.00000000000000E+003",
        "6.73475287613300E-029",
        "31.80",
        "1.00100000000000E+003",
        "6.67821343532828E-029",
        "31.90",
        "9.99000000000000E+002",
        "6.62733031405675E-029",
        "32.00",
        "1.00000000000000E+003",
        "6.58028531810189E-029",
        "32.10",
        "1.00100000000000E+003",
        "6.53890503626729E-029",
        "32.20",
        "9.99000000000000E+002",
        "6.45082219987872E-029",
        "32.30",
        "1.00100000000000E+003",
        "6.41346030495682E-029",
        "32.40",
        "1.00000000000000E+003",
        "6.37217752280941E-029",
        "32.50",
        "9.99000000000000E+002",
        "6.31361434351385E-029",
        "32.60",
        "1.00100000000000E+003",
        "6.28809188900663E-029",
        "32.70",
        "1.00000000000000E+003",
        "6.21487318262329E-029",
        "32.80",
        "9.99000000000000E+002",
        "6.17307660634533E-029",
        "32.90",
        "1.00100000000000E+003",
        "6.15734727098115E-029",
        "33.00",
        "9.99000000000000E+002",
        "6.08479375574515E-029",
        "33.10",
        "1.00000000000000E+003",
        "6.05250104118819E-029",
        "33.20",
        "1.00100000000000E+003",
        "6.01439592818364E-029",
        "33.30",
        "9.99000000000000E+002",
        "5.95172829497632E-029",
        "33.40",
        "1.00100000000000E+003",
        "5.93533066898613E-029",
        "33.50",
        "1.00000000000000E+003",
        "5.85662226347743E-029",
        "33.60",
        "9.99000000000000E+002",
        "5.78784744636726E-029",
        "33.70",
        "1.00100000000000E+003",
        "5.77571558682053E-029",
        "33.80",
        "9.99000000000000E+002",
        "5.73757486564941E-029",
        "33.90",
        "1.00000000000000E+003",
        "5.69171683146326E-029",
        "34.00",
        "1.00100000000000E+003",
        "5.63612203070142E-029",
        "34.10",
        "9.99000000000000E+002",
        "5.63182297099406E-029",
        "34.20",
        "1.00100000000000E+003",
        "5.54428170482713E-029",
        "34.30",
        "1.00000000000000E+003",
        "5.54207466129682E-029",
        "34.40",
        "9.98000000000000E+002",
        "5.45500310729373E-029",
        "34.50",
        "1.00100000000000E+003",
        "5.45057240223418E-029",
        "34.60",
        "9.99000000000000E+002",
        "5.39628132169216E-029",
        "34.70",
        "1.00000000000000E+003",
        "5.39556285024738E-029",
        "34.80",
        "1.00100000000000E+003",
        "5.33892813060950E-029",
        "34.90",
        "9.99000000000000E+002",
        "5.27415841614873E-029",
        "35.00",
        "1.00100000000000E+003",
        "5.26078500817015E-029",
        "35.10",
        "1.00000000000000E+003",
        "5.22234162621084E-029",
        "35.20",
        "9.99000000000000E+002",
        "5.18982401185350E-029",
        "35.30",
        "1.00100000000000E+003",
        "5.14775355132254E-029",
        "35.40",
        "9.99000000000000E+002",
        "5.11800829324098E-029",
        "35.50",
        "1.00100000000000E+003",
        "5.08686518276856E-029",
        "35.60",
        "1.00000000000000E+003",
        "5.03554685635767E-029",
        "35.70",
        "9.98000000000000E+002",
        "4.98578274712362E-029",
        "35.80",
        "1.00100000000000E+003",
        "4.96874948588196E-029",
        "35.90",
        "9.99000000000000E+002",
        "4.91647643479721E-029",
        "36.00",
        "1.00000000000000E+003",
        "4.87429644766260E-029",
        "36.10",
        "1.00100000000000E+003",
        "4.86666699680264E-029",
        "36.20",
        "9.98000000000000E+002",
        "4.80468499474973E-029",
        "36.30",
        "1.00000000000000E+003",
        "4.79678858363547E-029",
        "36.40",
        "9.99000000000000E+002",
        "4.75642478533906E-029",
        "36.50",
        "1.00000000000000E+003",
        "4.74332624917390E-029",
        "36.60",
        "1.00100000000000E+003",
        "4.69518186355156E-029",
        "36.70",
        "9.99000000000000E+002",
        "4.66243247297687E-029",
        "36.80",
        "1.00100000000000E+003",
        "4.63148703367291E-029",
        "36.90",
        "9.99000000000000E+002",
        "4.58801660305295E-029",
        "37.00",
        "1.00000000000000E+003",
        "4.58391164069996E-029",
        "37.10",
        "1.00100000000000E+003",
        "4.51595621472632E-029",
        "37.20",
        "9.98000000000000E+002",
        "4.49815153921633E-029",
        "37.30",
        "1.00100000000000E+003",
        "4.48208716102209E-029",
        "37.40",
        "9.99000000000000E+002",
        "4.42407945735913E-029",
        "37.50",
        "1.00100000000000E+003",
        "4.42136503862485E-029",
        "37.60",
        "1.00000000000000E+003",
        "4.39001367788981E-029",
        "37.70",
        "9.99000000000000E+002",
        "4.34921242911013E-029",
        "37.80",
        "1.00100000000000E+003",
        "4.31479641497920E-029",
        "37.90",
        "9.99000000000000E+002",
        "4.28500593696921E-029",
        "38.00",
        "1.00100000000000E+003",
        "4.27664982104517E-029",
        "38.10",
        "1.00000000000000E+003",
        "4.23106163456359E-029",
        "38.20",
        "9.99000000000000E+002",
        "4.19715551713163E-029",
        "38.30",
        "1.00100000000000E+003",
        "4.17352086227109E-029",
        "38.40",
        "9.99000000000000E+002",
        "4.13307986985053E-029",
        "38.50",
        "1.00100000000000E+003",
        "4.13552905715499E-029",
        "38.60",
        "9.99000000000000E+002",
        "4.09232404896181E-029",
        "38.70",
        "1.00000000000000E+003",
        "4.07771202976624E-029",
        "38.80",
        "1.00100000000000E+003",
        "4.05599882183837E-029",
        "38.90",
        "9.99000000000000E+002",
        "4.00293885816557E-029",
        "39.00",
        "1.00100000000000E+003",
        "3.99748591373017E-029",
        "39.10",
        "9.98000000000000E+002",
        "3.96411964761213E-029",
        "39.20",
        "1.00100000000000E+003",
        "3.94525975084149E-029",
        "39.30",
        "9.99000000000000E+002",
        "3.91425765756338E-029",
        "39.40",
        "1.00000000000000E+003",
        "3.88369871792793E-029",
        "39.50",
        "1.00100000000000E+003",
        "3.87172800804319E-029",
        "39.60",
        "9.99000000000000E+002",
        "3.83751315321028E-029",
        "39.70",
        "1.00100000000000E+003",
        "3.82557859170741E-029",
        "39.80",
        "9.99000000000000E+002",
        "3.79348820132551E-029",
        "39.90",
        "1.00100000000000E+003",
        "3.78661718902176E-029",
        "40.00",
        "1.00000000000000E+003",
        "3.75070976669538E-029",
        "40.10",
        "9.99000000000000E+002",
        "3.71737193707897E-029",
        "40.20",
        "1.00100000000000E+003",
        "3.69827185244232E-029",
        "40.30",
        "9.99000000000000E+002",
        "3.67509947765055E-029",
        "40.40",
        "1.00100000000000E+003",
        "3.65754276720356E-029",
        "40.50",
        "9.99000000000000E+002",
        "3.61773194549456E-029",
        "40.60",
        "1.00100000000000E+003",
        "3.60928674712292E-029",
        "40.70",
        "1.00000000000000E+003",
        "3.58114702114082E-029",
        "40.80",
        "9.99000000000000E+002",
        "3.55547888788013E-029",
        "40.90",
        "1.00000000000000E+003",
        "3.55020673994382E-029",
        "41.00",
        "9.98000000000000E+002",
        "3.50245492391960E-029",
        "41.10",
        "1.00100000000000E+003",
        "3.49525301201839E-029",
        "41.20",
        "9.98000000000000E+002",
        "3.46986230384411E-029",
        "41.30",
        "1.00100000000000E+003",
        "3.45719759049178E-029",
        "41.40",
        "9.99000000000000E+002",
        "3.43519569406669E-029",
        "41.50",
        "1.00000000000000E+003",
        "3.41832263783817E-029",
        "41.60",
        "1.00000000000000E+003",
        "3.40366416280799E-029",
        "41.70",
        "9.99000000000000E+002",
        "3.35986653882360E-029",
        "41.80",
        "1.00100000000000E+003",
        "3.36378904855233E-029",
        "41.90",
        "9.99000000000000E+002",
        "3.31715758680326E-029",
        "42.00",
        "1.00100000000000E+003",
        "3.30381762549561E-029",
        "42.10",
        "9.99000000000000E+002",
        "3.28850756653840E-029",
        "42.20",
        "1.00100000000000E+003",
        "3.26544861337561E-029",
        "42.30",
        "9.98000000000000E+002",
        "3.24250829257571E-029",
        "42.40",
        "9.99000000000000E+002",
        "3.23765945675571E-029",
        "42.50",
        "1.00100000000000E+003",
        "3.20801643879601E-029",
        "42.60",
        "9.99000000000000E+002",
        "3.18275076887860E-029",
        "42.70",
        "1.00100000000000E+003",
        "3.17724351207277E-029",
        "42.80",
        "9.99000000000000E+002",
        "3.14958940494184E-029",
        "42.90",
        "1.00100000000000E+003",
        "3.13337784036820E-029",
        "43.00",
        "9.98000000000000E+002",
        "3.11215239839896E-029",
        "43.10",
        "1.00100000000000E+003",
        "3.10132988403327E-029",
        "43.20",
        "1.00000000000000E+003",
        "3.06952185426339E-029",
        "43.30",
        "9.99000000000000E+002",
        "3.05632151542299E-029",
        "43.40",
        "1.00100000000000E+003",
        "3.04760331015561E-029",
        "43.50",
        "9.99000000000000E+002",
        "3.02715689141937E-029",
        "43.60",
        "1.00100000000000E+003",
        "3.01326665063272E-029",
        "43.70",
        "9.99000000000000E+002",
        "2.99263841607593E-029",
        "43.80",
        "1.00100000000000E+003",
        "2.97731912409586E-029",
        "43.90",
        "9.99000000000000E+002",
        "2.96131883452351E-029",
        "44.00",
        "1.00100000000000E+003",
        "2.94598917642276E-029",
        "44.10",
        "9.99000000000000E+002",
        "2.92591246065905E-029",
        "44.20",
        "1.00000000000000E+003",
        "2.90927118097728E-029",
        "44.30",
        "1.00100000000000E+003",
        "2.88123463135540E-029",
        "44.40",
        "9.99000000000000E+002",
        "2.87110733865248E-029",
        "44.50",
        "1.00100000000000E+003",
        "2.86492551732637E-029",
        "44.60",
        "9.99000000000000E+002",
        "2.82912795310382E-029",
        "44.70",
        "1.00100000000000E+003",
        "2.83119847320288E-029",
        "44.80",
        "9.99000000000000E+002",
        "2.80931277185203E-029",
        "44.90",
        "1.00100000000000E+003",
        "2.79665587681289E-029",
        "45.00",
        "9.99000000000000E+002",
        "2.77455324201688E-029",
        "45.10",
        "1.00100000000000E+003",
        "2.76407906639912E-029",
        "45.20",
        "9.99000000000000E+002",
        "2.73280600289425E-029",
        "45.30",
        "1.00100000000000E+003",
        "2.72502992760995E-029",
        "45.40",
        "1.00000000000000E+003",
        "2.71129808719007E-029",
        "45.50",
        "9.99000000000000E+002",
        "2.70082014746864E-029",
        "45.60",
        "1.00100000000000E+003",
        "2.68040977740947E-029",
        "45.70",
        "9.99000000000000E+002",
        "2.66761869483729E-029",
        "45.80",
        "1.00100000000000E+003",
        "2.65737464599794E-029",
        "45.90",
        "9.99000000000000E+002",
        "2.63755120951796E-029",
        "46.00",
        "1.00100000000000E+003",
        "2.62418573583055E-029",
        "46.10",
        "9.99000000000000E+002",
        "2.60356733496492E-029",
        "46.20",
        "1.00100000000000E+003",
        "2.59589498534829E-029",
        "46.30",
        "9.99000000000000E+002",
        "2.58233315379506E-029",
        "46.40",
        "1.00100000000000E+003",
        "2.56754763888234E-029",
        "46.50",
        "9.99000000000000E+002",
        "2.55948581197482E-029",
        "46.60",
        "1.00000000000000E+003",
        "2.53669487299298E-029",
        "46.70",
        "1.00000000000000E+003",
        "2.53154832585018E-029",
        "46.80",
        "9.99000000000000E+002",
        "2.50426485873332E-029",
        "46.90",
        "1.00100000000000E+003",
        "2.49335245224672E-029",
        "47.00",
        "9.99000000000000E+002",
        "2.47563744761828E-029",
        "47.10",
        "1.00100000000000E+003",
        "2.47243087633011E-029",
        "47.20",
        "9.99000000000000E+002",
        "2.45087368610429E-029",
        "47.30",
        "1.00000000000000E+003",
        "2.44325872821159E-029",
        "47.40",
        "9.99000000000000E+002",
        "2.42228745676966E-029",
        "47.50",
        "1.00100000000000E+003",
        "2.42103956325693E-029",
        "47.60",
        "9.99000000000000E+002",
        "2.39969976711906E-029",
        "47.70",
        "1.00100000000000E+003",
        "2.39637649108627E-029",
        "47.80",
        "9.99000000000000E+002",
        "2.37276201630943E-029",
        "47.90",
        "1.00100000000000E+003",
        "2.36232221102867E-029",
        "48.00",
        "9.99000000000000E+002",
        "2.34703210313721E-029",
        "48.10",
        "1.00000000000000E+003",
        "2.33828211467476E-029",
        "48.20",
        "1.00000000000000E+003",
        "2.32265862372246E-029",
        "48.30",
        "9.99000000000000E+002",
        "2.31411554907893E-029",
        "48.40",
        "1.00100000000000E+003",
        "2.30817060945565E-029",
        "48.50",
        "9.98000000000000E+002",
        "2.28749069571820E-029",
        "48.60",
        "1.00100000000000E+003",
        "2.28496359160853E-029",
        "48.70",
        "9.99000000000000E+002",
        "2.26103098482198E-029",
        "48.80",
        "1.00100000000000E+003",
        "2.25231100063370E-029",
        "48.90",
        "9.98000000000000E+002",
        "2.23430035035422E-029",
        "49.00",
        "1.00100000000000E+003",
        "2.23422131039232E-029",
        "49.10",
        "9.99000000000000E+002",
        "2.20725609926566E-029",
        "49.20",
        "1.00000000000000E+003",
        "2.21206897708213E-029",
        "49.30",
        "9.99000000000000E+002",
        "2.19474777178531E-029",
        "49.40",
        "1.00000000000000E+003",
        "2.18451191930459E-029",
        "49.50",
        "9.99000000000000E+002",
        "2.17478016920446E-029",
        "49.60",
        "1.00100000000000E+003",
        "2.16092740663260E-029",
        "49.70",
        "9.99000000000000E+002",
        "2.15367010300370E-029",
        "49.80",
        "1.00100000000000E+003",
        "2.13750877004945E-029",
        "49.90",
        "9.99000000000000E+002",
        "2.12915137045547E-029",
        "50.00",
        "1.00100000000000E+003",
        "2.11844136377866E-029",
        "50.10",
        "1.00000000000000E+003",
        "2.10521843063136E-029",
        "50.20",
        "9.99000000000000E+002",
        "2.09113168131502E-029",
        "50.30",
        "1.00100000000000E+003",
        "2.08786350381934E-029",
        "50.40",
        "9.99000000000000E+002",
        "2.07226629819138E-029",
        "50.50",
        "1.00100000000000E+003",
        "2.06805326759291E-029",
        "50.60",
        "9.99000000000000E+002",
        "2.05461932606011E-029",
        "50.70",
        "1.00000000000000E+003",
        "2.04691741068312E-029",
        "50.80",
        "9.99000000000000E+002",
        "2.02799867153332E-029",
        "50.90",
        "1.00000000000000E+003",
        "2.02012410497317E-029",
        "51.00",
        "9.99000000000000E+002",
        "2.01104276658083E-029",
        "51.10",
        "1.00100000000000E+003",
        "2.00723381575626E-029",
        "51.20",
        "9.99000000000000E+002",
        "1.99265422729484E-029",
        "51.30",
        "1.00100000000000E+003",
        "1.98403661358189E-029",
        "51.40",
        "9.98000000000000E+002",
        "1.96700114678646E-029",
        "51.50",
        "1.00100000000000E+003",
        "1.96351710072511E-029",
        "51.60",
        "9.99000000000000E+002",
        "1.95060016745746E-029",
        "51.70",
        "1.00100000000000E+003",
        "1.94684936596799E-029",
        "51.80",
        "9.99000000000000E+002",
        "1.92978466375510E-029",
        "51.90",
        "1.00100000000000E+003",
        "1.92866985355596E-029",
        "52.00",
        "9.99000000000000E+002",
        "1.91229332759557E-029",
        "52.10",
        "1.00000000000000E+003",
        "1.90659837986729E-029",
        "52.20",
        "9.99000000000000E+002",
        "1.89488813882223E-029",
        "52.30",
        "1.00000000000000E+003",
        "1.88356663608583E-029",
        "52.40",
        "9.99000000000000E+002",
        "1.87319493608653E-029",
        "52.50",
        "1.00100000000000E+003",
        "1.87110643738752E-029",
        "52.60",
        "9.99000000000000E+002",
        "1.85462358507355E-029",
        "52.70",
        "1.00000000000000E+003",
        "1.85029519235654E-029",
        "52.80",
        "9.98000000000000E+002",
        "1.83786653762792E-029",
        "52.90",
        "1.00000000000000E+003",
        "1.83085832549377E-029",
        "53.00",
        "1.00100000000000E+003",
        "1.82698277974025E-029",
        "53.10",
        "9.99000000000000E+002",
        "1.80992248817751E-029",
        "53.20",
        "1.00100000000000E+003",
        "1.80730348664555E-029",
        "53.30",
        "9.98000000000000E+002",
        "1.78760028723757E-029",
        "53.40",
        "1.00100000000000E+003",
        "1.79634615821081E-029",
        "53.50",
        "9.99000000000000E+002",
        "1.77780099956900E-029",
        "53.60",
        "1.00100000000000E+003",
        "1.77029669302095E-029",
        "53.70",
        "9.99000000000000E+002",
        "1.76092876127396E-029",
        "53.80",
        "1.00100000000000E+003",
        "1.75339959362441E-029",
        "53.90",
        "9.99000000000000E+002",
        "1.74305330130742E-029",
        "54.00",
        "1.00000000000000E+003",
        "1.73414931198745E-029",
        "54.10",
        "9.98000000000000E+002",
        "1.72743533068897E-029",
        "54.20",
        "1.00100000000000E+003",
        "1.71973526939569E-029",
        "54.30",
        "9.98000000000000E+002",
        "1.71352892128713E-029",
        "54.40",
        "1.00100000000000E+003",
        "1.70633841403010E-029",
        "54.50",
        "9.98000000000000E+002",
        "1.69597228775520E-029",
        "54.60",
        "1.00100000000000E+003",
        "1.68933312123030E-029",
        "54.70",
        "9.99000000000000E+002",
        "1.67920573442873E-029",
        "54.80",
        "1.00100000000000E+003",
        "1.67217889644770E-029",
        "54.90",
        "9.98000000000000E+002",
        "1.65895267000784E-029",
        "55.00",
        "1.00100000000000E+003",
        "1.66070024808655E-029",
        "55.10",
        "9.99000000000000E+002",
        "1.64263892436100E-029",
        "55.20",
        "1.00100000000000E+003",
        "1.64401257453595E-029",
        "55.30",
        "9.99000000000000E+002",
        "1.63062497072020E-029",
        "55.40",
        "1.00100000000000E+003",
        "1.62777363714414E-029",
        "55.50",
        "9.99000000000000E+002",
        "1.61619948757656E-029",
        "55.60",
        "1.00100000000000E+003",
        "1.61143572090854E-029",
        "55.70",
        "9.98000000000000E+002",
        "1.60218767812088E-029",
        "55.80",
        "1.00000000000000E+003",
        "1.59449983326764E-029",
        "55.90",
        "9.99000000000000E+002",
        "1.59449043345005E-029",
        "56.00",
        "1.00100000000000E+003",
        "1.58425858559229E-029",
        "56.10",
        "9.98000000000000E+002",
        "1.57123347792463E-029",
        "56.20",
        "1.00100000000000E+003",
        "1.56919196787471E-029",
        "56.30",
        "9.99000000000000E+002",
        "1.56122128501023E-029",
        "56.40",
        "1.00100000000000E+003",
        "1.55556066866875E-029",
        "56.50",
        "9.99000000000000E+002",
        "1.54589822654846E-029",
        "56.60",
        "1.00100000000000E+003",
        "1.53882163000710E-029",
        "56.70",
        "9.99000000000000E+002",
        "1.53289851465707E-029",
        "56.80",
        "1.00000000000000E+003",
        "1.52756831417503E-029",
        "56.90",
        "9.99000000000000E+002",
        "1.51494764194807E-029",
        "57.00",
        "1.00100000000000E+003",
        "1.50953392680322E-029",
        "57.10",
        "9.99000000000000E+002",
        "1.50211379343809E-029",
        "57.20",
        "1.00100000000000E+003",
        "1.49457256830901E-029",
        "57.30",
        "9.99000000000000E+002",
        "1.49162572796667E-029",
        "57.40",
        "1.00100000000000E+003",
        "1.48444649966931E-029",
        "57.50",
        "9.98000000000000E+002",
        "1.47783670714711E-029",
        "57.60",
        "1.00100000000000E+003",
        "1.47275119249131E-029",
        "57.70",
        "9.99000000000000E+002",
        "1.46612632694972E-029",
        "57.80",
        "1.00100000000000E+003",
        "1.45678049112452E-029",
        "57.90",
        "9.99000000000000E+002",
        "1.44987436076389E-029",
        "58.00",
        "1.00000000000000E+003",
        "1.44151596912180E-029",
        "58.10",
        "9.99000000000000E+002",
        "1.43806477136683E-029",
        "58.20",
        "1.00000000000000E+003",
        "1.43000988619220E-029",
        "58.30",
        "9.99000000000000E+002",
        "1.42535377375914E-029",
        "58.40",
        "1.00100000000000E+003",
        "1.41781290678320E-029",
        "58.50",
        "9.99000000000000E+002",
        "1.41264877081055E-029",
        "58.60",
        "9.99000000000000E+002",
        "1.40568865823502E-029",
        "58.70",
        "9.99000000000000E+002",
        "1.39593670644979E-029",
        "58.80",
        "1.00100000000000E+003",
        "1.39641852612069E-029",
        "58.90",
        "9.97000000000000E+002",
        "1.38789285249711E-029",
        "59.00",
        "1.00100000000000E+003",
        "1.38371786162216E-029",
        "59.10",
        "9.99000000000000E+002",
        "1.37582630573112E-029",
        "59.20",
        "1.00100000000000E+003",
        "1.37018893907961E-029",
        "59.30",
        "9.99000000000000E+002",
        "1.36113968959712E-029",
        "59.40",
        "1.00100000000000E+003",
        "1.35952875402972E-029",
        "59.50",
        "9.99000000000000E+002",
        "1.35163547618290E-029",
        "59.60",
        "1.00100000000000E+003",
        "1.34926521092288E-029",
        "59.70",
        "9.99000000000000E+002",
        "1.33909834830735E-029",
        "59.80",
        "1.00000000000000E+003",
        "1.33454066939010E-029",
        "59.90",
        "9.99000000000000E+002",
        "1.32936376211330E-029",
        "60.00",
        "1.00100000000000E+003",
        "1.32185710506498E-029",
        "60.10",
        "9.99000000000000E+002",
        "1.31776948192914E-029",
        "60.20",
        "1.00100000000000E+003",
        "1.30982421485596E-029",
        "60.30",
        "9.99000000000000E+002",
        "1.30674867070431E-029",
        "60.40",
        "1.00000000000000E+003",
        "1.30027676486153E-029",
        "60.50",
        "9.99000000000000E+002",
        "1.29706344731150E-029",
        "60.60",
        "1.00100000000000E+003",
        "1.29103279304554E-029",
        "60.70",
        "9.99000000000000E+002",
        "1.28349620404187E-029",
        "60.80",
        "1.00100000000000E+003",
        "1.27877971520961E-029",
        "60.90",
        "9.99000000000000E+002",
        "1.27080276078469E-029",
        "61.00",
        "9.99000000000000E+002",
        "1.26705683871789E-029",
        "61.10",
        "9.99000000000000E+002",
        "1.26236898732862E-029",
        "61.20",
        "1.00100000000000E+003",
        "1.25954934124584E-029",
        "61.30",
        "9.99000000000000E+002",
        "1.25296409556561E-029",
        "61.40",
        "1.00100000000000E+003",
        "1.24853822368781E-029",
        "61.50",
        "9.99000000000000E+002",
        "1.24134268660802E-029",
        "61.60",
        "1.00000000000000E+003",
        "1.23458210102215E-029",
        "61.70",
        "9.98000000000000E+002",
        "1.23002135200895E-029",
        "61.80",
        "1.00100000000000E+003",
        "1.22439702580038E-029",
        "61.90",
        "9.98000000000000E+002",
        "1.21640120333607E-029",
        "62.00",
        "1.00100000000000E+003",
        "1.21349446819097E-029",
        "62.10",
        "9.98000000000000E+002",
        "1.20931561423933E-029",
        "62.20",
        "1.00100000000000E+003",
        "1.20849376240956E-029",
        "62.30",
        "9.99000000000000E+002",
        "1.19829785104615E-029",
        "62.40",
        "1.00100000000000E+003",
        "1.19481926443997E-029",
        "62.50",
        "9.98000000000000E+002",
        "1.18697063709898E-029",
        "62.60",
        "1.00100000000000E+003",
        "1.18656804424793E-029",
        "62.70",
        "9.99000000000000E+002",
        "1.17976717423019E-029",
        "62.80",
        "1.00100000000000E+003",
        "1.17734569234719E-029",
        "62.90",
        "9.99000000000000E+002",
        "1.16667940713706E-029",
        "63.00",
        "1.00100000000000E+003",
        "1.17129273360189E-029",
        "63.10",
        "9.99000000000000E+002",
        "1.16020479135070E-029",
        "63.20",
        "1.00100000000000E+003",
        "1.15778926716650E-029",
        "63.30",
        "9.99000000000000E+002",
        "1.15016438468570E-029",
        "63.40",
        "1.00000000000000E+003",
        "1.14741681813642E-029",
        "63.50",
        "1.00100000000000E+003",
        "1.14366535216500E-029",
        "63.60",
        "9.98000000000000E+002",
        "1.13361737079620E-029",
        "63.70",
        "1.00100000000000E+003",
        "1.13089072317380E-029",
        "63.80",
        "9.99000000000000E+002",
        "1.12825549601743E-029",
        "63.90",
        "1.00100000000000E+003",
        "1.12391175515930E-029",
        "64.00",
        "9.98000000000000E+002",
        "1.11620880871073E-029",
        "64.10",
        "1.00100000000000E+003",
        "1.11300513862174E-029",
        "64.20",
        "9.99000000000000E+002",
        "1.10699923220900E-029",
        "64.30",
        "1.00100000000000E+003",
        "1.10852321230261E-029",
        "64.40",
        "9.99000000000000E+002",
        "1.10121294383617E-029",
        "64.50",
        "1.00100000000000E+003",
        "1.10002220294995E-029",
        "64.60",
        "9.99000000000000E+002",
        "1.09129416229491E-029",
        "64.70",
        "1.00100000000000E+003",
        "1.08989352727991E-029",
        "64.80",
        "9.99000000000000E+002",
        "1.08233533718133E-029",
        "64.90",
        "1.00000000000000E+003",
        "1.07922064195990E-029",
        "65.00",
        "9.99000000000000E+002",
        "1.07570487347624E-029",
        "65.10",
        "1.00000000000000E+003",
        "1.07073077762808E-029",
        "65.20",
        "9.99000000000000E+002",
        "1.06545522021673E-029",
        "65.30",
        "1.00100000000000E+003",
        "1.06509162521945E-029",
        "65.40",
        "9.99000000000000E+002",
        "1.05748954358415E-029",
        "65.50",
        "1.00000000000000E+003",
        "1.05457812910420E-029",
        "65.60",
        "9.99000000000000E+002",
        "1.04767285662446E-029",
        "65.70",
        "1.00100000000000E+003",
        "1.04805744178987E-029",
        "65.80",
        "9.99000000000000E+002",
        "1.03983697585873E-029",
        "65.90",
        "1.00100000000000E+003",
        "1.03970947003015E-029",
        "66.00",
        "9.99000000000000E+002",
        "1.03168702281868E-029",
        "66.10",
        "1.00100000000000E+003",
        "1.02997112623138E-029",
        "66.20",
        "9.99000000000000E+002",
        "1.02561889986815E-029",
        "66.30",
        "1.00100000000000E+003",
        "1.02258858407157E-029",
        "66.40",
        "9.99000000000000E+002",
        "1.01607382935440E-029",
        "66.50",
        "1.00100000000000E+003",
        "1.01527593720953E-029",
        "66.60",
        "9.99000000000000E+002",
        "1.00689364267708E-029",
        "66.70",
        "1.00100000000000E+003",
        "1.00513582898930E-029",
        "66.80",
        "9.99000000000000E+002",
        "1.00149512964485E-029",
        "66.90",
        "1.00100000000000E+003",
        "9.97329754198275E-030",
        "67.00",
        "9.99000000000000E+002",
        "9.90900403941527E-030",
        "67.10",
        "9.99000000000000E+002",
        "9.89608202405439E-030",
        "67.20",
        "1.00100000000000E+003",
        "9.87187887293109E-030",
        "67.30",
        "9.99000000000000E+002",
        "9.81588192601051E-030",
        "67.40",
        "1.00000000000000E+003",
        "9.77606483627287E-030",
        "67.50",
        "9.99000000000000E+002",
        "9.73660332753260E-030",
        "67.60",
        "1.00100000000000E+003",
        "9.73801740435184E-030",
        "67.70",
        "9.99000000000000E+002",
        "9.65521136905645E-030",
        "67.80",
        "1.00100000000000E+003",
        "9.64753876444753E-030",
        "67.90",
        "9.99000000000000E+002",
        "9.59017347864396E-030",
        "68.00",
        "1.00100000000000E+003",
        "9.57224273307690E-030",
        "68.10",
        "9.99000000000000E+002",
        "9.54072918770638E-030",
        "68.20",
        "1.00100000000000E+003",
        "9.48701083878051E-030",
        "68.30",
        "9.99000000000000E+002",
        "9.42879659063430E-030",
        "68.40",
        "9.99000000000000E+002",
        "9.39190062994750E-030",
        "68.50",
        "9.99000000000000E+002",
        "9.37219348117301E-030",
        "68.60",
        "1.00000000000000E+003",
        "9.35978512430196E-030",
        "68.70",
        "9.99000000000000E+002",
        "9.29327710057722E-030",
        "68.80",
        "1.00100000000000E+003",
        "9.28221958642028E-030",
        "68.90",
        "9.99000000000000E+002",
        "9.23855210058026E-030",
        "69.00",
        "1.00000000000000E+003",
        "9.21350906944663E-030",
        "69.10",
        "9.99000000000000E+002",
        "9.15767410199611E-030",
        "69.20",
        "1.00000000000000E+003",
        "9.13427160853580E-030",
        "69.30",
        "9.99000000000000E+002",
        "9.10538217275023E-030",
        "69.40",
        "1.00100000000000E+003",
        "9.07925888716697E-030",
        "69.50",
        "9.99000000000000E+002",
        "9.03568593540760E-030",
        "69.60",
        "9.98000000000000E+002",
        "8.96638660339351E-030",
        "69.70",
        "1.00100000000000E+003",
        "8.98792826122381E-030",
        "69.80",
        "9.99000000000000E+002",
        "8.92902140226013E-030",
        "69.90",
        "1.00100000000000E+003",
        "8.88486453303448E-030",
        "70.00",
        "9.98000000000000E+002",
        "8.85922900626770E-030",
        "70.10",
        "1.00100000000000E+003",
        "8.86946745791853E-030",
        "70.20",
        "9.99000000000000E+002",
        "8.79986511996600E-030",
        "70.30",
        "1.00100000000000E+003",
        "8.79457514549850E-030",
        "70.40",
        "9.96000000000000E+002",
        "8.69269882289113E-030",
        "70.50",
        "1.00100000000000E+003",
        "8.73626265562180E-030",
        "70.60",
        "9.99000000000000E+002",
        "8.65746663431120E-030",
        "70.70",
        "1.00000000000000E+003",
        "8.64157594018403E-030",
        "70.80",
        "9.99000000000000E+002",
        "8.60764972918163E-030",
        "70.90",
        "1.00000000000000E+003",
        "8.58412877340181E-030",
        "71.00",
        "9.99000000000000E+002",
        "8.54532774543504E-030",
        "71.10",
        "1.00100000000000E+003",
        "8.50408259906012E-030",
        "71.20",
        "9.99000000000000E+002",
        "8.47224756072374E-030",
        "71.30",
        "1.00100000000000E+003",
        "8.44435953401026E-030",
        "71.40",
        "9.99000000000000E+002",
        "8.41790040809172E-030",
        "71.50",
        "1.00100000000000E+003",
        "8.39989353283822E-030",
        "71.60",
        "9.99000000000000E+002",
        "8.35358892716556E-030",
        "71.70",
        "1.00100000000000E+003",
        "8.33008377146836E-030",
        "71.80",
        "9.99000000000000E+002",
        "8.28798897402262E-030",
        "71.90",
        "1.00000000000000E+003",
        "8.25428248987259E-030",
        "72.00",
        "1.00100000000000E+003",
        "8.23435663149464E-030",
        "72.10",
        "9.99000000000000E+002",
        "8.20230060578482E-030",
        "72.20",
        "1.00100000000000E+003",
        "8.19463317282894E-030",
        "72.30",
        "9.99000000000000E+002",
        "8.14307180076299E-030",
        "72.40",
        "9.99000000000000E+002",
        "8.09886926328507E-030",
        "72.50",
        "9.99000000000000E+002",
        "8.07603424400031E-030",
        "72.60",
        "9.99000000000000E+002",
        "8.05740382782448E-030",
        "72.70",
        "9.99000000000000E+002",
        "8.03135757849914E-030",
        "72.80",
        "1.00000000000000E+003",
        "8.02156164007507E-030",
        "72.90",
        "9.99000000000000E+002",
        "7.97193897034748E-030",
        "73.00",
        "1.00100000000000E+003",
        "7.94266027922071E-030",
        "73.10",
        "9.99000000000000E+002",
        "7.90564859048579E-030",
        "73.20",
        "1.00100000000000E+003",
        "7.90172025630983E-030",
        "73.30",
        "9.99000000000000E+002",
        "7.84979360007426E-030",
        "73.40",
        "1.00100000000000E+003",
        "7.83635168385555E-030",
        "73.50",
        "9.99000000000000E+002",
        "7.79748052738701E-030",
        "73.60",
        "1.00100000000000E+003",
        "7.77655189925865E-030",
        "73.70",
        "9.99000000000000E+002",
        "7.73733231505280E-030",
        "73.80",
        "1.00000000000000E+003",
        "7.70124779409459E-030",
        "73.90",
        "1.00000000000000E+003",
        "7.70041406654484E-030",
        "74.00",
        "9.99000000000000E+002",
        "7.64531547217332E-030",
        "74.10",
        "1.00100000000000E+003",
        "7.64298357049622E-030",
        "74.20",
        "9.99000000000000E+002",
        "7.61848931071673E-030",
        "74.30",
        "1.00100000000000E+003",
        "7.58639816421811E-030",
        "74.40",
        "9.99000000000000E+002",
        "7.55354736135417E-030",
        "74.50",
        "1.00100000000000E+003",
        "7.55626691118906E-030",
        "74.60",
        "9.99000000000000E+002",
        "7.50002143639216E-030",
        "74.70",
        "1.00100000000000E+003",
        "7.48846719788669E-030",
        "74.80",
        "9.98000000000000E+002",
        "7.45353006035569E-030",
        "74.90",
        "1.00100000000000E+003",
        "7.44721297218733E-030",
        "75.00",
        "9.98000000000000E+002",
        "7.38469164598242E-030",
        "75.10",
        "1.00100000000000E+003",
        "7.39289363263882E-030",
        "75.20",
        "9.99000000000000E+002",
        "7.34546634832855E-030",
        "75.30",
        "1.00100000000000E+003",
        "7.32655962493508E-030",
        "75.40",
        "9.98000000000000E+002",
        "7.28157894978095E-030",
        "75.50",
        "1.00000000000000E+003",
        "7.29738028469249E-030",
        "75.60",
        "9.99000000000000E+002",
        "7.25013463495832E-030",
        "75.70",
        "1.00100000000000E+003",
        "7.22952220800139E-030",
        "75.80",
        "9.99000000000000E+002",
        "7.20321721952421E-030",
        "75.90",
        "9.99000000000000E+002",
        "7.18678778392211E-030",
        "76.00",
        "1.00000000000000E+003",
        "7.15497493136877E-030",
        "76.10",
        "9.99000000000000E+002",
        "7.12450757229956E-030",
        "76.20",
        "1.00100000000000E+003",
        "7.11216471932435E-030",
        "76.30",
        "9.99000000000000E+002",
        "7.05918342076335E-030",
        "76.40",
        "1.00100000000000E+003",
        "7.07660782690929E-030",
        "76.50",
        "9.99000000000000E+002",
        "7.01950781239663E-030",
        "76.60",
        "1.00100000000000E+003",
        "7.00955646099127E-030",
        "76.70",
        "9.99000000000000E+002",
        "6.97029204202884E-030",
        "76.80",
        "1.00100000000000E+003",
        "6.96760902549844E-030",
        "76.90",
        "9.99000000000000E+002",
        "6.92727168077884E-030",
        "77.00",
        "1.00100000000000E+003",
        "6.93334739080778E-030",
        "77.10",
        "9.99000000000000E+002",
        "6.88611686705869E-030",
        "77.20",
        "1.00100000000000E+003",
        "6.88404507507033E-030",
        "77.30",
        "9.99000000000000E+002",
        "6.84284490619747E-030",
        "77.40",
        "1.00100000000000E+003",
        "6.82731423457713E-030",
        "77.50",
        "1.00000000000000E+003",
        "6.80003677670402E-030",
        "77.60",
        "9.98000000000000E+002",
        "6.76629909557584E-030",
        "77.70",
        "1.00100000000000E+003",
        "6.76497387541675E-030",
        "77.80",
        "9.99000000000000E+002",
        "6.72684681968937E-030",
        "77.90",
        "1.00100000000000E+003",
        "6.71311246797237E-030",
        "78.00",
        "9.99000000000000E+002",
        "6.67762681987745E-030",
        "78.10",
        "1.00100000000000E+003",
        "6.67709792314277E-030",
        "78.20",
        "9.99000000000000E+002",
        "6.62972526930542E-030",
        "78.30",
        "1.00100000000000E+003",
        "6.61826348114631E-030",
        "78.40",
        "9.98000000000000E+002",
        "6.58348884327410E-030",
        "78.50",
        "1.00100000000000E+003",
        "6.58415226441463E-030",
        "78.60",
        "9.99000000000000E+002",
        "6.54354952071550E-030",
        "78.70",
        "1.00100000000000E+003",
        "6.54052617690887E-030",
        "78.80",
        "9.99000000000000E+002",
        "6.51111671326138E-030",
        "78.90",
        "1.00100000000000E+003",
        "6.50149792515843E-030",
        "79.00",
        "9.99000000000000E+002",
        "6.46129483846952E-030",
        "79.10",
        "1.00000000000000E+003",
        "6.44410259329381E-030",
        "79.20",
        "1.00100000000000E+003",
        "6.43301098300468E-030",
        "79.30",
        "9.99000000000000E+002",
        "6.39891133028982E-030",
        "79.40",
        "1.00000000000000E+003",
        "6.38287668256880E-030",
        "79.50",
        "9.99000000000000E+002",
        "6.36817714291543E-030",
        "79.60",
        "1.00100000000000E+003",
        "6.34985689504225E-030",
        "79.70",
        "9.99000000000000E+002",
        "6.30871435069585E-030",
        "79.80",
        "1.00000000000000E+003",
        "6.30241062910237E-030",
        "79.90",
        "9.99000000000000E+002",
        "6.26952110933655E-030",
        "80.00",
        "1.00000000000000E+003",
        "6.24979221172519E-030",
        "80.10",
        "9.99000000000000E+002",
        "6.23105606614604E-030",
        "80.20",
        "1.00100000000000E+003",
        "6.21247085190308E-030",
        "80.30",
        "9.99000000000000E+002",
        "6.19663806278593E-030",
        "80.40",
        "1.00100000000000E+003",
        "6.17908241719439E-030",
        "80.50",
        "9.98000000000000E+002",
        "6.13502061908936E-030",
        "80.60",
        "1.00100000000000E+003",
        "6.14345354723616E-030",
        "80.70",
        "1.00000000000000E+003",
        "6.10887262132938E-030",
        "80.80",
        "9.99000000000000E+002",
        "6.08888820878093E-030",
        "80.90",
        "1.00100000000000E+003",
        "6.07708202496092E-030",
        "81.00",
        "9.99000000000000E+002",
        "6.05782909500856E-030",
        "81.10",
        "1.00000000000000E+003",
        "6.02875614087288E-030",
        "81.20",
        "9.99000000000000E+002",
        "6.01302110775500E-030",
        "81.30",
        "1.00100000000000E+003",
        "5.99956506916362E-030",
        "81.40",
        "9.97000000000000E+002",
        "5.96563522418758E-030",
        "81.50",
        "1.00100000000000E+003",
        "5.96832717482791E-030",
        "81.60",
        "9.98000000000000E+002",
        "5.92792014847125E-030",
        "81.70",
        "1.00100000000000E+003",
        "5.93821520671449E-030",
        "81.80",
        "9.99000000000000E+002",
        "5.90174461480334E-030",
        "81.90",
        "1.00100000000000E+003",
        "5.88286708163429E-030",
        "82.00",
        "9.99000000000000E+002",
        "5.86169124643622E-030",
        "82.10",
        "1.00000000000000E+003",
        "5.84655407824977E-030",
        "82.20",
        "1.00000000000000E+003",
        "5.84208239013077E-030",
        "82.30",
        "9.98000000000000E+002",
        "5.79293813401322E-030",
        "82.40",
        "1.00100000000000E+003",
        "5.79812822384620E-030",
        "82.50",
        "9.98000000000000E+002",
        "5.76122267339991E-030",
        "82.60",
        "1.00100000000000E+003",
        "5.76067595777850E-030",
        "82.70",
        "9.99000000000000E+002",
        "5.72712851905897E-030",
        "82.80",
        "1.00100000000000E+003",
        "5.72471997393604E-030",
        "82.90",
        "9.99000000000000E+002",
        "5.68415078755030E-030",
        "83.00",
        "1.00100000000000E+003",
        "5.67901757451756E-030",
        "83.10",
        "9.99000000000000E+002",
        "5.65289507399726E-030",
        "83.20",
        "1.00000000000000E+003",
        "5.64392475385277E-030",
        "83.30",
        "9.98000000000000E+002",
        "5.62229511350700E-030",
        "83.40",
        "1.00100000000000E+003",
        "5.62434519819670E-030",
        "83.50",
        "9.99000000000000E+002",
        "5.57634286849486E-030",
        "83.60",
        "1.00100000000000E+003",
        "5.57536452745551E-030",
        "83.70",
        "1.00000000000000E+003",
        "5.55144993331864E-030",
        "83.80",
        "9.99000000000000E+002",
        "5.52938162207949E-030",
        "83.90",
        "1.00100000000000E+003",
        "5.52050717331657E-030",
        "84.00",
        "9.98000000000000E+002",
        "5.49166960948843E-030",
        "84.10",
        "1.00100000000000E+003",
        "5.49872741609716E-030",
        "84.20",
        "9.99000000000000E+002",
        "5.46629722370461E-030",
        "84.30",
        "1.00100000000000E+003",
        "5.46767203224370E-030",
        "84.40",
        "9.99000000000000E+002",
        "5.43331398968090E-030",
        "84.50",
        "1.00100000000000E+003",
        "5.42363162064517E-030",
        "84.60",
        "9.99000000000000E+002",
        "5.38419476326932E-030",
        "84.70",
        "1.00100000000000E+003",
        "5.39773554860695E-030",
        "84.80",
        "9.98000000000000E+002",
        "5.35919777815128E-030",
        "84.90",
        "1.00100000000000E+003",
        "5.35191438089330E-030",
        "85.00",
        "9.99000000000000E+002",
        "5.33290657757452E-030",
        "85.10",
        "1.00000000000000E+003",
        "5.33056919470058E-030",
        "85.20",
        "1.00100000000000E+003",
        "5.31862867202731E-030",
        "85.30",
        "9.99000000000000E+002",
        "5.29034878985009E-030",
        "85.40",
        "1.00100000000000E+003",
        "5.27848945341429E-030",
        "85.50",
        "9.98000000000000E+002",
        "5.25047157745629E-030",
        "85.60",
        "1.00100000000000E+003",
        "5.24326580384215E-030",
        "85.70",
        "9.98000000000000E+002",
        "5.21949795443570E-030",
        "85.80",
        "1.00100000000000E+003",
        "5.20997591487406E-030",
        "85.90",
        "9.99000000000000E+002",
        "5.19390772640312E-030",
        "86.00",
        "1.00000000000000E+003",
        "5.17966354534009E-030",
        "86.10",
        "9.99000000000000E+002",
        "5.15043754794506E-030",
        "86.20",
        "1.00100000000000E+003",
        "5.14773090950048E-030",
        "86.30",
        "9.99000000000000E+002",
        "5.13085083402229E-030",
        "86.40",
        "1.00000000000000E+003",
        "5.11186564497862E-030",
        "86.50",
        "1.00100000000000E+003",
        "5.10097757805565E-030",
        "86.60",
        "9.99000000000000E+002",
        "5.06835582508669E-030",
        "86.70",
        "1.00000000000000E+003",
        "5.07051295291627E-030",
        "86.80",
        "9.98000000000000E+002",
        "5.04582715637856E-030",
        "86.90",
        "1.00000000000000E+003",
        "5.04351418513306E-030",
        "87.00",
        "9.98000000000000E+002",
        "5.01194342892905E-030",
        "87.10",
        "9.99000000000000E+002",
        "5.00030726964508E-030",
        "87.20",
        "9.99000000000000E+002",
        "4.98275647866055E-030",
        "87.30",
        "1.00000000000000E+003",
        "4.97201515892187E-030",
        "87.40",
        "9.99000000000000E+002",
        "4.95396408806994E-030",
        "87.50",
        "1.00100000000000E+003",
        "4.95391774213072E-030",
        "87.60",
        "9.99000000000000E+002",
        "4.92325660896542E-030",
        "87.70",
        "1.00100000000000E+003",
        "4.92349479881667E-030",
        "87.80",
        "9.99000000000000E+002",
        "4.89788607638328E-030",
        "87.90",
        "9.99000000000000E+002",
        "4.88312828858060E-030",
        "88.00",
        "1.00100000000000E+003",
        "4.87710396957768E-030",
        "88.10",
        "9.98000000000000E+002",
        "4.84769050473836E-030",
        "88.20",
        "1.00100000000000E+003",
        "4.84773504425843E-030",
        "88.30",
        "9.99000000000000E+002",
        "4.82076583416041E-030",
        "88.40",
        "1.00100000000000E+003",
        "4.81885037833791E-030",
        "88.50",
        "9.99000000000000E+002",
        "4.79032683040157E-030",
        "88.60",
        "1.00100000000000E+003",
        "4.78641419622496E-030",
        "88.70",
        "9.99000000000000E+002",
        "4.76627999257863E-030",
        "88.80",
        "1.00100000000000E+003",
        "4.77357498442398E-030",
        "88.90",
        "9.99000000000000E+002",
        "4.74421276396025E-030",
        "89.00",
        "1.00100000000000E+003",
        "4.73136198722725E-030",
        "89.10",
        "1.00000000000000E+003",
        "4.71173580212860E-030",
        "89.20",
        "9.98000000000000E+002",
        "4.69265956501743E-030",
        "89.30",
        "1.00100000000000E+003",
        "4.69278062617173E-030",
        "89.40",
        "9.99000000000000E+002",
        "4.66901903649826E-030",
        "89.50",
        "1.00100000000000E+003",
        "4.66268333458968E-030",
        "89.60",
        "9.98000000000000E+002",
        "4.63408502413131E-030",
        "89.70",
        "1.00000000000000E+003",
        "4.63225374335667E-030",
        "89.80",
        "9.96000000000000E+002",
        "4.60194858653645E-030",
        "89.90",
        "1.00100000000000E+003",
        "4.60364609704170E-030",
        "90.00",
        "9.99000000000000E+002",
        "4.59028731830679E-030",
        "90.10",
        "1.00100000000000E+003",
        "4.59382232885670E-030",
        "90.20",
        "9.99000000000000E+002",
        "4.56013812219105E-030",
        "90.30",
        "9.98000000000000E+002",
        "4.54766828972036E-030",
        "90.40",
        "1.00100000000000E+003",
        "4.54708462851439E-030",
        "90.50",
        "9.99000000000000E+002",
        "4.51901935162268E-030",
        "90.60",
        "1.00100000000000E+003",
        "4.51412726939325E-030",
        "90.70",
        "9.99000000000000E+002",
        "4.50105796550560E-030",
        "90.80",
        "1.00100000000000E+003",
        "4.49912800522088E-030",
        "90.90",
        "9.99000000000000E+002",
        "4.46675244462325E-030",
        "91.00",
        "1.00100000000000E+003",
        "4.46095277983658E-030",
        "91.10",
        "9.99000000000000E+002",
        "4.45055030989044E-030",
        "91.20",
        "1.00100000000000E+003",
        "4.44056984883856E-030",
        "91.30",
        "9.98000000000000E+002",
        "4.41864331504626E-030",
        "91.40",
        "1.00100000000000E+003",
        "4.41482688276600E-030",
        "91.50",
        "9.99000000000000E+002",
        "4.39638578806241E-030",
        "91.60",
        "1.00000000000000E+003",
        "4.38996395481152E-030",
        "91.70",
        "1.00000000000000E+003",
        "4.36817709130576E-030",
        "91.80",
        "9.98000000000000E+002",
        "4.35061361285650E-030",
        "91.90",
        "1.00000000000000E+003",
        "4.34765668288708E-030",
        "92.00",
        "9.99000000000000E+002",
        "4.33238822018087E-030",
        "92.10",
        "1.00100000000000E+003",
        "4.32608402959879E-030",
        "92.20",
        "9.99000000000000E+002",
        "4.31024104315675E-030",
        "92.30",
        "9.99000000000000E+002",
        "4.30426923359605E-030",
        "92.40",
        "9.98000000000000E+002",
        "4.27864999501874E-030",
        "92.50",
        "1.00100000000000E+003",
        "4.27937363166767E-030",
        "92.60",
        "9.98000000000000E+002",
        "4.25369289864240E-030",
        "92.70",
        "1.00100000000000E+003",
        "4.25251428223615E-030",
        "92.80",
        "1.00000000000000E+003",
        "4.24059594064472E-030",
        "92.90",
        "9.99000000000000E+002",
        "4.22451957804219E-030",
        "93.00",
        "1.00100000000000E+003",
        "4.22575337777207E-030",
        "93.10",
        "9.98000000000000E+002",
        "4.19625678654738E-030",
        "93.20",
        "1.00100000000000E+003",
        "4.19654607984543E-030",
        "93.30",
        "9.99000000000000E+002",
        "4.17564633644715E-030",
        "93.40",
        "1.00100000000000E+003",
        "4.16720981251003E-030",
        "93.50",
        "9.99000000000000E+002",
        "4.15525257295818E-030",
        "93.60",
        "1.00100000000000E+003",
        "4.14615676442812E-030",
        "93.70",
        "9.98000000000000E+002",
        "4.11864745588728E-030",
        "93.80",
        "1.00000000000000E+003",
        "4.12943262414061E-030",
        "93.90",
        "9.97000000000000E+002",
        "4.09952691628387E-030",
        "94.00",
        "1.00000000000000E+003",
        "4.10101731704511E-030",
        "94.10",
        "1.00100000000000E+003",
        "4.09490118184977E-030",
        "94.20",
        "9.99000000000000E+002",
        "4.07242991572160E-030",
        "94.30",
        "1.00100000000000E+003",
        "4.06751254173655E-030",
        "94.40",
        "9.98000000000000E+002",
        "4.05525123714991E-030",
        "94.50",
        "1.00100000000000E+003",
        "4.04466783352207E-030",
        "94.60",
        "9.98000000000000E+002",
        "4.02817055922919E-030",
        "94.70",
        "1.00100000000000E+003",
        "4.02476228590158E-030",
        "94.80",
        "9.99000000000000E+002",
        "4.00671379127181E-030",
        "94.90",
        "1.00100000000000E+003",
        "4.00451946860852E-030",
        "95.00",
        "9.99000000000000E+002",
        "3.97959804323537E-030",
        "95.10",
        "1.00100000000000E+003",
        "3.98347794554912E-030",
        "95.20",
        "1.00000000000000E+003",
        "3.96705590027913E-030",
        "95.30",
        "9.98000000000000E+002",
        "3.94166915313135E-030",
        "95.40",
        "1.00100000000000E+003",
        "3.94708973652064E-030",
        "95.50",
        "9.99000000000000E+002",
        "3.92049026492094E-030",
        "95.60",
        "1.00100000000000E+003",
        "3.92717390068808E-030",
        "95.70",
        "9.99000000000000E+002",
        "3.91111470874764E-030",
        "95.80",
        "1.00100000000000E+003",
        "3.90633183619860E-030",
        "95.90",
        "9.99000000000000E+002",
        "3.87832151906885E-030",
        "96.00",
        "1.00100000000000E+003",
        "3.88267329791603E-030",
        "96.10",
        "9.99000000000000E+002",
        "3.86651833192513E-030",
        "96.20",
        "1.00100000000000E+003",
        "3.86561357262914E-030",
        "96.30",
        "9.98000000000000E+002",
        "3.83716761923545E-030",
        "96.40",
        "1.00000000000000E+003",
        "3.83070053744196E-030",
        "96.50",
        "1.00000000000000E+003",
        "3.82373457591627E-030",
        "96.60",
        "9.99000000000000E+002",
        "3.81203008217899E-030",
        "96.70",
        "1.00000000000000E+003",
        "3.80713480225338E-030",
        "96.80",
        "9.98000000000000E+002",
        "3.78629155345571E-030",
        "96.90",
        "1.00100000000000E+003",
        "3.79016544421161E-030",
        "97.00",
        "9.99000000000000E+002",
        "3.76302003333334E-030",
        "97.10",
        "1.00100000000000E+003",
        "3.76157849430275E-030",
        "97.20",
        "9.98000000000000E+002",
        "3.74234404277923E-030",
        "97.30",
        "1.00100000000000E+003",
        "3.74441058696177E-030",
        "97.40",
        "9.98000000000000E+002",
        "3.73116039010406E-030",
        "97.50",
        "9.99000000000000E+002",
        "3.72143790796774E-030",
        "97.60",
        "1.00100000000000E+003",
        "3.72143339204738E-030",
        "97.70",
        "9.99000000000000E+002",
        "3.69861460660797E-030",
        "97.80",
        "1.00100000000000E+003",
        "3.69192899905910E-030",
        "97.90",
        "9.99000000000000E+002",
        "3.68051382689963E-030",
        "98.00",
        "1.00100000000000E+003",
        "3.67459178769241E-030",
        "98.10",
        "9.99000000000000E+002",
        "3.66078663640347E-030",
        "98.20",
        "1.00100000000000E+003",
        "3.65633420909905E-030",
        "98.30",
        "9.98000000000000E+002",
        "3.63281381898347E-030",
        "98.40",
        "1.00100000000000E+003",
        "3.63536706170211E-030",
        "98.50",
        "9.99000000000000E+002",
        "3.62085774627076E-030",
        "98.60",
        "1.00000000000000E+003",
        "3.61303285473167E-030",
        "98.70",
        "9.99000000000000E+002",
        "3.59632619103261E-030",
        "98.80",
        "9.99000000000000E+002",
        "3.59367310760906E-030",
        "98.90",
        "1.00100000000000E+003",
        "3.59249164311605E-030",
        "99.00",
        "9.99000000000000E+002",
        "3.57305676663265E-030",
        "99.10",
        "1.00100000000000E+003",
        "3.57228758327523E-030",
        "99.20",
        "9.98000000000000E+002",
        "3.55194675315441E-030",
        "99.30",
        "1.00100000000000E+003",
        "3.55230635911277E-030",
        "99.40",
        "9.98000000000000E+002",
        "3.53097844710566E-030",
        "99.50",
        "1.00100000000000E+003",
        "3.53167145409772E-030",
        "99.60",
        "9.99000000000000E+002",
        "3.51671589313065E-030",
        "99.70",
        "1.00100000000000E+003",
        "3.51296803157559E-030",
        "99.80",
        "9.98000000000000E+002",
        "3.49739722637406E-030",
        "99.90",
        "9.98000000000000E+002",
        "3.48367423637400E-030",
        "100.00",
        "1.00100000000000E+003",
        "3.48593718715321E-030",
        "100.10",
        "9.99000000000000E+002",
        "3.46998336379732E-030",
        "100.20",
        "1.00100000000000E+003",
        "3.47137545253171E-030",
        "100.30",
        "9.99000000000000E+002",
        "3.45726008700879E-030",
        "100.40",
        "1.00100000000000E+003",
        "3.45075539656468E-030",
        "100.50",
        "9.99000000000000E+002",
        "3.43629298904474E-030",
        "100.60",
        "1.00100000000000E+003",
        "3.42532285327698E-030",
        "100.70",
        "9.99000000000000E+002",
        "3.42266852416669E-030",
        "100.80",
        "1.00000000000000E+003",
        "3.40842008715672E-030",
        "100.90",
        "1.00000000000000E+003",
        "3.40329397814593E-030",
        "101.00",
        "9.99000000000000E+002",
        "3.38438440504629E-030",
        "101.10",
        "1.00100000000000E+003",
        "3.39094888396782E-030",
        "101.20",
        "9.99000000000000E+002",
        "3.37367022761527E-030",
        "101.30",
        "1.00100000000000E+003",
        "3.37024366888619E-030",
        "101.40",
        "9.99000000000000E+002",
        "3.35639302665071E-030",
        "101.50",
        "1.00100000000000E+003",
        "3.34969898842679E-030",
        "101.60",
        "9.99000000000000E+002",
        "3.33483196863158E-030",
        "101.70",
        "9.99000000000000E+002",
        "3.32563153865316E-030",
        "101.80",
        "9.99000000000000E+002",
        "3.32404519129959E-030",
        "101.90",
        "1.00100000000000E+003",
        "3.32033806885148E-030",
        "102.00",
        "1.00000000000000E+003",
        "3.30511991057734E-030",
        "102.10",
        "9.99000000000000E+002",
        "3.29397747217369E-030",
        "102.20",
        "1.00100000000000E+003",
        "3.29398503690111E-030",
        "102.30",
        "9.99000000000000E+002",
        "3.27636316275664E-030",
        "102.40",
        "1.00100000000000E+003",
        "3.27955060291362E-030",
        "102.50",
        "9.99000000000000E+002",
        "3.26096961246086E-030",
        "102.60",
        "1.00100000000000E+003",
        "3.25582825253970E-030",
        "102.70",
        "9.99000000000000E+002",
        "3.24340074219636E-030",
        "102.80",
        "1.00100000000000E+003",
        "3.24276522519040E-030",
        "102.90",
        "9.99000000000000E+002",
        "3.22524751153261E-030",
        "103.00",
        "1.00000000000000E+003",
        "3.22576075000607E-030",
        "103.10",
        "9.98000000000000E+002",
        "3.20895799844982E-030",
        "103.20",
        "9.98000000000000E+002",
        "3.20135700934708E-030",
        "103.30",
        "1.00100000000000E+003",
        "3.20063434354157E-030",
        "103.40",
        "9.99000000000000E+002",
        "3.19065238047007E-030",
        "103.50",
        "1.00100000000000E+003",
        "3.18150308003580E-030",
        "103.60",
        "9.99000000000000E+002",
        "3.17373443451492E-030",
        "103.70",
        "1.00100000000000E+003",
        "3.16661387775098E-030",
        "103.80",
        "9.99000000000000E+002",
        "3.15104938174206E-030",
        "103.90",
        "1.00000000000000E+003",
        "3.14945034737949E-030",
        "104.00",
        "9.99000000000000E+002",
        "3.13115910438648E-030",
        "104.10",
        "1.00100000000000E+003",
        "3.13450776190971E-030",
        "104.20",
        "1.00000000000000E+003",
        "3.12561209155306E-030",
        "104.30",
        "9.98000000000000E+002",
        "3.10803830431548E-030",
        "104.40",
        "1.00100000000000E+003",
        "3.11113332833820E-030",
        "104.50",
        "9.99000000000000E+002",
        "3.09745726147164E-030",
        "104.60",
        "1.00100000000000E+003",
        "3.09660436587090E-030",
        "104.70",
        "9.99000000000000E+002",
        "3.08564432337908E-030",
        "104.80",
        "1.00100000000000E+003",
        "3.07952456553926E-030",
        "104.90",
        "9.98000000000000E+002",
        "3.06405810365561E-030",
        "105.00",
        "1.00000000000000E+003",
        "3.06027393121058E-030",
        "105.10",
        "9.99000000000000E+002",
        "3.05009358722729E-030",
        "105.20",
        "9.99000000000000E+002",
        "3.04541043750820E-030",
        "105.30",
        "1.00100000000000E+003",
        "3.03876968612331E-030",
        "105.40",
        "9.99000000000000E+002",
        "3.03201380857270E-030",
        "105.50",
        "1.00100000000000E+003",
        "3.03211710393400E-030",
        "105.60",
        "9.99000000000000E+002",
        "3.00859574860383E-030",
        "105.70",
        "1.00100000000000E+003",
        "3.01226765290747E-030",
        "105.80",
        "9.99000000000000E+002",
        "3.00234352663875E-030",
        "105.90",
        "1.00100000000000E+003",
        "2.99427216148782E-030",
        "106.00",
        "9.99000000000000E+002",
        "2.98564006890720E-030",
        "106.10",
        "1.00100000000000E+003",
        "2.98312576451619E-030",
        "106.20",
        "9.97000000000000E+002",
        "2.96464267064238E-030",
        "106.30",
        "1.00000000000000E+003",
        "2.96600675490884E-030",
        "106.40",
        "1.00100000000000E+003",
        "2.95827602079324E-030",
        "106.50",
        "9.99000000000000E+002",
        "2.94467874428670E-030",
        "106.60",
        "1.00100000000000E+003",
        "2.94685090675274E-030",
        "106.70",
        "9.99000000000000E+002",
        "2.92892480009916E-030",
        "106.80",
        "1.00100000000000E+003",
        "2.92867318909835E-030",
        "106.90",
        "9.98000000000000E+002",
        "2.91897143018476E-030",
        "107.00",
        "1.00100000000000E+003",
        "2.91818159736927E-030",
        "107.10",
        "9.99000000000000E+002",
        "2.90305936559159E-030",
        "107.20",
        "1.00100000000000E+003",
        "2.90266213538501E-030",
        "107.30",
        "1.00000000000000E+003",
        "2.89338453561276E-030",
        "107.40",
        "9.99000000000000E+002",
        "2.88457158900166E-030",
        "107.50",
        "1.00100000000000E+003",
        "2.88398182406348E-030",
        "107.60",
        "9.99000000000000E+002",
        "2.87051670065212E-030",
        "107.70",
        "1.00100000000000E+003",
        "2.86773171807354E-030",
        "107.80",
        "9.99000000000000E+002",
        "2.85510123526901E-030",
        "107.90",
        "1.00100000000000E+003",
        "2.85506153018766E-030",
        "108.00",
        "9.99000000000000E+002",
        "2.83714995606125E-030",
        "108.10",
        "1.00000000000000E+003",
        "2.83584795184914E-030",
        "108.20",
        "9.98000000000000E+002",
        "2.82270441724343E-030",
        "108.30",
        "9.99000000000000E+002",
        "2.82226273822329E-030",
        "108.40",
        "9.99000000000000E+002",
        "2.81545616487442E-030",
        "108.50",
        "9.99000000000000E+002",
        "2.80191832661912E-030",
        "108.60",
        "1.00000000000000E+003",
        "2.80001260853615E-030",
        "108.70",
        "9.98000000000000E+002",
        "2.78827061673062E-030",
        "108.80",
        "1.00000000000000E+003",
        "2.78585727497322E-030",
        "108.90",
        "9.99000000000000E+002",
        "2.78195827556314E-030",
        "109.00",
        "1.00100000000000E+003",
        "2.77824156296826E-030",
        "109.10",
        "9.99000000000000E+002",
        "2.76812330551279E-030",
        "109.20",
        "1.00100000000000E+003",
        "2.76199907892040E-030",
        "109.30",
        "9.99000000000000E+002",
        "2.75206666553973E-030",
        "109.40",
        "9.99000000000000E+002",
        "2.74537425176595E-030",
        "109.50",
        "1.00100000000000E+003",
        "2.74537688131951E-030",
        "109.60",
        "9.99000000000000E+002",
        "2.73112403160913E-030",
        "109.70",
        "1.00000000000000E+003",
        "2.73156824367595E-030",
        "109.80",
        "9.99000000000000E+002",
        "2.71983673618065E-030",
        "109.90",
        "1.00100000000000E+003",
        "2.71710287479465E-030",
        "110.00",
        "9.99000000000000E+002",
        "2.70564160768941E-030",
        "110.10",
        "1.00000000000000E+003",
        "2.70345418179737E-030",
        "110.20",
        "9.99000000000000E+002",
        "2.69310696539617E-030",
        "110.30",
        "1.00000000000000E+003",
        "2.69022941549444E-030",
        "110.40",
        "1.00000000000000E+003",
        "2.68384930286197E-030",
        "110.50",
        "9.98000000000000E+002",
        "2.67308506305359E-030",
        "110.60",
        "1.00100000000000E+003",
        "2.67204064158022E-030",
        "110.70",
        "9.98000000000000E+002",
        "2.65751556661004E-030",
        "110.80",
        "1.00000000000000E+003",
        "2.66130120906028E-030",
        "110.90",
        "9.99000000000000E+002",
        "2.64867603268584E-030",
        "111.00",
        "1.00100000000000E+003",
        "2.64634845083820E-030",
        "111.10",
        "9.99000000000000E+002",
        "2.63667178535754E-030",
        "111.20",
        "1.00100000000000E+003",
        "2.63716416924093E-030",
        "111.30",
        "9.98000000000000E+002",
        "2.61832181766145E-030",
        "111.40",
        "1.00100000000000E+003",
        "2.62095016966664E-030",
        "111.50",
        "9.99000000000000E+002",
        "2.61103302642771E-030",
        "111.60",
        "9.99000000000000E+002",
        "2.60483428898583E-030",
        "111.70",
        "1.00100000000000E+003",
        "2.60783045190390E-030",
        "111.80",
        "9.99000000000000E+002",
        "2.58873358712101E-030",
        "111.90",
        "9.99000000000000E+002",
        "2.58585298193884E-030",
        "112.00",
        "9.97000000000000E+002",
        "2.57781386393543E-030",
        "112.10",
        "1.00100000000000E+003",
        "2.57561657951637E-030",
        "112.20",
        "9.99000000000000E+002",
        "2.56811830824755E-030",
        "112.30",
        "1.00000000000000E+003",
        "2.56639117486959E-030",
        "112.40",
        "9.99000000000000E+002",
        "2.55319625003694E-030",
        "112.50",
        "1.00000000000000E+003",
        "2.55416263293432E-030",
        "112.60",
        "1.00000000000000E+003",
        "2.55021709852957E-030",
        "112.70",
        "9.99000000000000E+002",
        "2.53904750603141E-030",
        "112.80",
        "1.00000000000000E+003",
        "2.53542911692507E-030",
        "112.90",
        "9.99000000000000E+002",
        "2.52822939271842E-030",
        "113.00",
        "1.00100000000000E+003",
        "2.52774046118272E-030",
        "113.10",
        "9.99000000000000E+002",
        "2.51503649559441E-030",
        "113.20",
        "1.00000000000000E+003",
        "2.51175779242570E-030",
        "113.30",
        "9.97000000000000E+002",
        "2.49775852444277E-030",
        "113.40",
        "1.00100000000000E+003",
        "2.50074627198185E-030",
        "113.50",
        "9.99000000000000E+002",
        "2.49250213180047E-030",
        "113.60",
        "9.98000000000000E+002",
        "2.48227579837954E-030",
        "113.70",
        "1.00000000000000E+003",
        "2.48660218980678E-030",
        "113.80",
        "9.98000000000000E+002",
        "2.47139396207713E-030",
        "113.90",
        "1.00000000000000E+003",
        "2.46863106230106E-030",
        "114.00",
        "9.99000000000000E+002",
        "2.46401833898147E-030",
        "114.10",
        "1.00000000000000E+003",
        "2.46023527289150E-030",
        "114.20",
        "9.99000000000000E+002",
        "2.45141835614542E-030",
        "114.30",
        "1.00000000000000E+003",
        "2.45346273818673E-030",
        "114.40",
        "9.98000000000000E+002",
        "2.43943966938861E-030",
        "114.50",
        "9.99000000000000E+002",
        "2.43401755854780E-030",
        "114.60",
        "1.00000000000000E+003",
        "2.43086311370348E-030",
        "114.70",
        "9.99000000000000E+002",
        "2.42424121402827E-030",
        "114.80",
        "1.00000000000000E+003",
        "2.41934683111775E-030",
        "114.90",
        "9.99000000000000E+002",
        "2.40909049353945E-030",
        "115.00",
        "1.00100000000000E+003",
        "2.40925525799060E-030",
        "115.10",
        "9.99000000000000E+002",
        "2.40298167839195E-030",
        "115.20",
        "1.00100000000000E+003",
        "2.39974953188894E-030",
        "115.30",
        "9.99000000000000E+002",
        "2.39244369627190E-030",
        "115.40",
        "1.00000000000000E+003",
        "2.38792889304245E-030",
        "115.50",
        "1.00000000000000E+003",
        "2.38343919085970E-030",
        "115.60",
        "9.98000000000000E+002",
        "2.37279197506188E-030",
        "115.70",
        "1.00000000000000E+003",
        "2.37094117136857E-030",
        "115.80",
        "9.99000000000000E+002",
        "2.36505984906857E-030",
        "115.90",
        "1.00100000000000E+003",
        "2.36185735989178E-030",
        "116.00",
        "9.99000000000000E+002",
        "2.35417213174659E-030",
        "116.10",
        "1.00100000000000E+003",
        "2.35074726699803E-030",
        "116.20",
        "9.99000000000000E+002",
        "2.34278201381022E-030",
        "116.30",
        "1.00100000000000E+003",
        "2.34403873884645E-030",
        "116.40",
        "9.99000000000000E+002",
        "2.33181483175170E-030",
        "116.50",
        "9.99000000000000E+002",
        "2.32709721780666E-030",
        "116.60",
        "1.00100000000000E+003",
        "2.32624250929485E-030",
        "116.70",
        "9.99000000000000E+002",
        "2.31536695593363E-030",
        "116.80",
        "1.00000000000000E+003",
        "2.31249732006330E-030",
        "116.90",
        "9.99000000000000E+002",
        "2.30782450278535E-030",
        "117.00",
        "1.00100000000000E+003",
        "2.30347929346824E-030",
        "117.10",
        "9.98000000000000E+002",
        "2.29110984621595E-030",
        "117.20",
        "1.00100000000000E+003",
        "2.29493213137534E-030",
        "117.30",
        "9.99000000000000E+002",
        "2.28405836846453E-030",
        "117.40",
        "1.00000000000000E+003",
        "2.28390140826901E-030",
        "117.50",
        "1.00100000000000E+003",
        "2.27927206527115E-030",
        "117.60",
        "9.99000000000000E+002",
        "2.26967543939493E-030",
        "117.70",
        "1.00100000000000E+003",
        "2.26893832340344E-030",
        "117.80",
        "9.98000000000000E+002",
        "2.25511521951590E-030",
        "117.90",
        "1.00100000000000E+003",
        "2.25758960604842E-030",
        "118.00",
        "9.99000000000000E+002",
        "2.24849539882477E-030",
        "118.10",
        "1.00100000000000E+003",
        "2.24712602838491E-030",
        "118.20",
        "9.99000000000000E+002",
        "2.23857979905410E-030",
        "118.30",
        "1.00100000000000E+003",
        "2.23797761996691E-030",
        "118.40",
        "9.99000000000000E+002",
        "2.22667298834268E-030",
        "118.50",
        "9.98000000000000E+002",
        "2.22068078927654E-030",
        "118.60",
        "1.00100000000000E+003",
        "2.22182934604961E-030",
        "118.70",
        "9.99000000000000E+002",
        "2.21549337090387E-030",
        "118.80",
        "1.00000000000000E+003",
        "2.20798840688887E-030",
        "118.90",
        "9.99000000000000E+002",
        "2.20225714085112E-030",
        "119.00",
        "1.00100000000000E+003",
        "2.20438066286484E-030",
        "119.10",
        "9.99000000000000E+002",
        "2.19549706621155E-030",
        "119.20",
        "1.00100000000000E+003",
        "2.19095613535822E-030",
        "119.30",
        "9.99000000000000E+002",
        "2.18672192438809E-030",
        "119.40",
        "1.00000000000000E+003",
        "2.18115030791280E-030",
        "119.50",
        "1.00100000000000E+003",
        "2.17829376579947E-030",
        "119.60",
        "9.99000000000000E+002",
        "2.16885707023389E-030",
        "119.70",
        "1.00100000000000E+003",
        "2.16937761121375E-030",
        "119.80",
        "9.97000000000000E+002",
        "2.15575112337742E-030",
        "119.90",
        "1.00100000000000E+003",
        "2.15985296464886E-030",
        "120.00",
        "9.99000000000000E+002",
        "2.14799789317258E-030",
        "120.10",
        "1.00100000000000E+003",
        "2.14905304875653E-030",
        "120.20",
        "9.99000000000000E+002",
        "2.14073159850448E-030",
        "120.30",
        "1.00000000000000E+003",
        "2.13933106468361E-030",
        "120.40",
        "1.00100000000000E+003",
        "2.13365926448156E-030",
        "120.50",
        "9.98000000000000E+002",
        "2.12666693214240E-030",
        "120.60",
        "1.00100000000000E+003",
        "2.12749965051562E-030",
        "120.70",
        "9.99000000000000E+002",
        "2.11823224054860E-030",
        "120.80",
        "1.00100000000000E+003",
        "2.11460521835837E-030",
        "120.90",
        "9.99000000000000E+002",
        "2.10802782786999E-030",
        "121.00",
        "1.00000000000000E+003",
        "2.10495203940862E-030",
        "121.10",
        "9.99000000000000E+002",
        "2.09885492668107E-030",
        "121.20",
        "1.00100000000000E+003",
        "2.09844183005401E-030",
        "121.30",
        "1.00000000000000E+003",
        "2.09318946754011E-030",
        "121.40",
        "9.99000000000000E+002",
        "2.08376462255573E-030",
        "121.50",
        "1.00100000000000E+003",
        "2.08288594920187E-030",
        "121.60",
        "9.98000000000000E+002",
        "2.07370340473588E-030",
        "121.70",
        "1.00000000000000E+003",
        "2.07635141931295E-030",
        "121.80",
        "9.99000000000000E+002",
        "2.06621019305334E-030",
        "121.90",
        "1.00100000000000E+003",
        "2.06779362662797E-030",
        "122.00",
        "9.99000000000000E+002",
        "2.06091473824310E-030",
        "122.10",
        "1.00100000000000E+003",
        "2.05846896338668E-030",
        "122.20",
        "9.98000000000000E+002",
        "2.04921200917843E-030",
        "122.30",
        "1.00000000000000E+003",
        "2.04438382512165E-030",
        "122.40",
        "1.00100000000000E+003",
        "2.04331139366589E-030",
        "122.50",
        "9.99000000000000E+002",
        "2.03898294911235E-030",
        "122.60",
        "1.00100000000000E+003",
        "2.03602748397150E-030",
        "122.70",
        "9.99000000000000E+002",
        "2.02596068413147E-030",
        "122.80",
        "1.00100000000000E+003",
        "2.02669098553181E-030",
        "122.90",
        "9.97000000000000E+002",
        "2.01449107762571E-030",
        "123.00",
        "1.00100000000000E+003",
        "2.01996951390961E-030",
        "123.10",
        "9.99000000000000E+002",
        "2.00971160370197E-030",
        "123.20",
        "1.00000000000000E+003",
        "2.00883485409045E-030",
        "123.30",
        "1.00000000000000E+003",
        "2.00436039277848E-030",
        "123.40",
        "9.99000000000000E+002",
        "1.99793866275117E-030",
        "123.50",
        "1.00100000000000E+003",
        "1.99681873151287E-030",
        "123.60",
        "9.98000000000000E+002",
        "1.98831865485507E-030",
        "123.70",
        "9.99000000000000E+002",
        "1.98570137492005E-030",
        "123.80",
        "9.98000000000000E+002",
        "1.97928173814523E-030",
        "123.90",
        "1.00100000000000E+003",
        "1.98123092602508E-030",
        "124.00",
        "9.99000000000000E+002",
        "1.97100251584322E-030",
        "124.10",
        "1.00100000000000E+003",
        "1.97303191383896E-030",
        "124.20",
        "1.00000000000000E+003",
        "1.96573532443037E-030",
        "124.30",
        "9.99000000000000E+002",
        "1.95994867688589E-030",
        "124.40",
        "1.00100000000000E+003",
        "1.95973564210495E-030",
        "124.50",
        "9.99000000000000E+002",
        "1.95204866234918E-030",
        "124.60",
        "1.00100000000000E+003",
        "1.94988560694063E-030",
        "124.70",
        "9.99000000000000E+002",
        "1.94196317208828E-030",
        "124.80",
        "1.00100000000000E+003",
        "1.94145519769557E-030",
        "124.90",
        "9.99000000000000E+002",
        "1.93196647855762E-030",
        "125.00",
        "1.00100000000000E+003",
        "1.93397124766972E-030",
        "125.10",
        "1.00000000000000E+003",
        "1.92666463134700E-030",
        "125.20",
        "9.98000000000000E+002",
        "1.91910348012750E-030",
        "125.30",
        "1.00100000000000E+003",
        "1.92211344798701E-030",
        "125.40",
        "9.99000000000000E+002",
        "1.91529685175304E-030",
        "125.50",
        "1.00100000000000E+003",
        "1.91297217532344E-030",
        "125.60",
        "9.99000000000000E+002",
        "1.90622959078594E-030",
        "125.70",
        "1.00100000000000E+003",
        "1.90547955234860E-030",
        "125.80",
        "9.99000000000000E+002",
        "1.90033567108393E-030",
        "125.90",
        "1.00000000000000E+003",
        "1.89805860846465E-030",
        "126.00",
        "1.00000000000000E+003",
        "1.89057682624982E-030",
        "126.10",
        "9.99000000000000E+002",
        "1.88721090051919E-030",
        "126.20",
        "1.00100000000000E+003",
        "1.88592966590324E-030",
        "126.30",
        "9.99000000000000E+002",
        "1.87881411881854E-030",
        "126.40",
        "1.00100000000000E+003",
        "1.87973192840255E-030",
        "126.50",
        "9.98000000000000E+002",
        "1.86735328537720E-030",
        "126.60",
        "1.00000000000000E+003",
        "1.87005576916275E-030",
        "126.70",
        "9.99000000000000E+002",
        "1.86356469262052E-030",
        "126.80",
        "1.00100000000000E+003",
        "1.86308073915435E-030",
        "126.90",
        "9.98000000000000E+002",
        "1.85193818942989E-030",
        "127.00",
        "1.00000000000000E+003",
        "1.85442465704710E-030",
        "127.10",
        "1.00100000000000E+003",
        "1.85038048430400E-030",
        "127.20",
        "9.98000000000000E+002",
        "1.84131034217877E-030",
        "127.30",
        "1.00100000000000E+003",
        "1.84360532223059E-030",
        "127.40",
        "9.99000000000000E+002",
        "1.83777208081577E-030",
        "127.50",
        "1.00000000000000E+003",
        "1.83342096590342E-030",
        "127.60",
        "9.99000000000000E+002",
        "1.82955829870267E-030",
        "127.70",
        "1.00000000000000E+003",
        "1.82452370760350E-030",
        "127.80",
        "9.99000000000000E+002",
        "1.82096103765247E-030",
        "127.90",
        "1.00000000000000E+003",
        "1.82026155649740E-030",
        "128.00",
        "1.00100000000000E+003",
        "1.81646476231946E-030",
        "128.10",
        "9.99000000000000E+002",
        "1.80885675236396E-030",
        "128.20",
        "1.00000000000000E+003",
        "1.80920163704655E-030",
        "128.30",
        "9.98000000000000E+002",
        "1.80006688130729E-030",
        "128.40",
        "1.00100000000000E+003",
        "1.80262694910677E-030",
        "128.50",
        "9.99000000000000E+002",
        "1.79587677771303E-030",
        "128.60",
        "9.99000000000000E+002",
        "1.79271932064876E-030",
        "128.70",
        "9.99000000000000E+002",
        "1.78618930806955E-030",
        "128.80",
        "1.00000000000000E+003",
        "1.78509357128597E-030",
        "128.90",
        "1.00100000000000E+003",
        "1.78218707665922E-030",
        "129.00",
        "9.98000000000000E+002",
        "1.77555546133997E-030",
        "129.10",
        "1.00000000000000E+003",
        "1.77411118298807E-030",
        "129.20",
        "9.99000000000000E+002",
        "1.76859436324441E-030",
        "129.30",
        "1.00100000000000E+003",
        "1.76917451139811E-030",
        "129.40",
        "9.99000000000000E+002",
        "1.76131780283538E-030",
        "129.50",
        "1.00000000000000E+003",
        "1.76070871299453E-030",
        "129.60",
        "9.99000000000000E+002",
        "1.75269900941730E-030",
        "129.70",
        "1.00100000000000E+003",
        "1.75508315358889E-030",
        "129.80",
        "1.00000000000000E+003",
        "1.74803966757657E-030",
        "129.90",
        "9.98000000000000E+002",
        "1.74237074680798E-030",
        "130.00",
        "1.00100000000000E+003",
        "1.74509238933395E-030",
        "130.10",
        "9.99000000000000E+002",
        "1.73628068288851E-030",
        "130.20",
        "1.00000000000000E+003",
        "1.73373662949717E-030",
        "130.30",
        "9.99000000000000E+002",
        "1.72985336412346E-030",
        "130.40",
        "1.00100000000000E+003",
        "1.72979873232100E-030",
        "130.50",
        "9.98000000000000E+002",
        "1.71866393394073E-030",
        "130.60",
        "1.00000000000000E+003",
        "1.72113482371012E-030",
        "130.70",
        "9.99000000000000E+002",
        "1.71728283561158E-030",
        "130.80",
        "9.98000000000000E+002",
        "1.71073061628342E-030",
        "130.90",
        "1.00000000000000E+003",
        "1.71069221204253E-030",
        "131.00",
        "9.99000000000000E+002",
        "1.70531683416689E-030",
        "131.10",
        "1.00000000000000E+003",
        "1.70247827144079E-030",
        "131.20",
        "9.99000000000000E+002",
        "1.69866977626655E-030",
        "131.30",
        "1.00100000000000E+003",
        "1.69788072366904E-030",
        "131.40",
        "9.99000000000000E+002",
        "1.69033091817390E-030",
        "131.50",
        "1.00100000000000E+003",
        "1.69038660587633E-030",
        "131.60",
        "1.00000000000000E+003",
        "1.68635405611786E-030",
        "131.70",
        "9.99000000000000E+002",
        "1.68166718136525E-030",
        "131.80",
        "1.00100000000000E+003",
        "1.68099631702574E-030",
        "131.90",
        "9.98000000000000E+002",
        "1.67436116174181E-030",
        "132.00",
        "1.00000000000000E+003",
        "1.67272542909315E-030",
        "132.10",
        "9.97000000000000E+002",
        "1.66482973504556E-030",
        "132.20",
        "1.00100000000000E+003",
        "1.66616299032332E-030",
        "132.30",
        "9.98000000000000E+002",
        "1.65938253489279E-030",
        "132.40",
        "1.00000000000000E+003",
        "1.65974293962842E-030",
        "132.50",
        "1.00000000000000E+003",
        "1.65640626604008E-030",
        "132.60",
        "9.99000000000000E+002",
        "1.65251267642967E-030",
        "132.70",
        "1.00100000000000E+003",
        "1.65193970331447E-030",
        "132.80",
        "9.99000000000000E+002",
        "1.64438676921128E-030",
        "132.90",
        "9.99000000000000E+002",
        "1.64154417193589E-030",
        "133.00",
        "9.99000000000000E+002",
        "1.63924733765429E-030",
        "133.10",
        "1.00000000000000E+003",
        "1.63476746355050E-030",
        "133.20",
        "9.96000000000000E+002",
        "1.62775313330859E-030",
        "133.30",
        "1.00100000000000E+003",
        "1.63069298311443E-030",
        "133.40",
        "9.99000000000000E+002",
        "1.62483150610652E-030",
        "133.50",
        "9.98000000000000E+002",
        "1.62142610655355E-030",
        "133.60",
        "1.00100000000000E+003",
        "1.62049515844869E-030",
        "133.70",
        "9.99000000000000E+002",
        "1.61785925358729E-030",
        "133.80",
        "1.00100000000000E+003",
        "1.61450340929635E-030",
        "133.90",
        "9.98000000000000E+002",
        "1.60770549786839E-030",
        "134.00",
        "1.00100000000000E+003",
        "1.60722571203707E-030",
        "134.10",
        "9.99000000000000E+002",
        "1.60265069000702E-030",
        "134.20",
        "1.00100000000000E+003",
        "1.60255082546860E-030",
        "134.30",
        "1.00000000000000E+003",
        "1.59916881232035E-030",
        "134.40",
        "9.99000000000000E+002",
        "1.59271058174619E-030",
        "134.50",
        "1.00100000000000E+003",
        "1.59014161183063E-030",
        "134.60",
        "9.99000000000000E+002",
        "1.58850007044722E-030",
        "134.70",
        "1.00100000000000E+003",
        "1.58763157196182E-030",
        "134.80",
        "9.99000000000000E+002",
        "1.58124758255196E-030",
        "134.90",
        "1.00100000000000E+003",
        "1.57932022144804E-030",
        "135.00",
        "9.99000000000000E+002",
        "1.57280741799630E-030",
        "135.10",
        "1.00100000000000E+003",
        "1.57625008052484E-030",
        "135.20",
        "1.00000000000000E+003",
        "1.57095396294234E-030",
        "135.30",
        "9.99000000000000E+002",
        "1.56545198147359E-030",
        "135.40",
        "1.00100000000000E+003",
        "1.56533995620597E-030",
        "135.50",
        "9.99000000000000E+002",
        "1.55955881373482E-030",
        "135.60",
        "1.00000000000000E+003",
        "1.55787230831847E-030",
        "135.70",
        "9.98000000000000E+002",
        "1.55228578133457E-030",
        "135.80",
        "1.00100000000000E+003",
        "1.55397415435485E-030",
        "135.90",
        "9.99000000000000E+002",
        "1.54646498570779E-030",
        "136.00",
        "1.00100000000000E+003",
        "1.54655285275336E-030",
        "136.10",
        "9.99000000000000E+002",
        "1.54168830317057E-030",
        "136.20",
        "9.98000000000000E+002",
        "1.53753129782814E-030",
        "136.30",
        "1.00100000000000E+003",
        "1.53817572948716E-030",
        "136.40",
        "9.99000000000000E+002",
        "1.53066911061600E-030",
        "136.50",
        "1.00000000000000E+003",
        "1.52893198422096E-030",
        "136.60",
        "9.98000000000000E+002",
        "1.52372914450717E-030",
        "136.70",
        "1.00100000000000E+003",
        "1.52617883449201E-030",
        "136.80",
        "9.99000000000000E+002",
        "1.52020976056073E-030",
        "136.90",
        "1.00100000000000E+003",
        "1.52038394873813E-030",
        "137.00",
        "9.99000000000000E+002",
        "1.51412438057363E-030",
        "137.10",
        "1.00000000000000E+003",
        "1.51246718383190E-030",
        "137.20",
        "1.00000000000000E+003",
        "1.50995877877922E-030",
        "137.30",
        "9.98000000000000E+002",
        "1.50495241973786E-030",
        "137.40",
        "1.00100000000000E+003",
        "1.50355184047810E-030",
        "137.50",
        "9.98000000000000E+002",
        "1.49752842098111E-030",
        "137.60",
        "9.99000000000000E+002",
        "1.49798411946427E-030",
        "137.70",
        "9.99000000000000E+002",
        "1.49411754089251E-030",
        "137.80",
        "1.00100000000000E+003",
        "1.49259518368528E-030",
        "137.90",
        "9.99000000000000E+002",
        "1.48730852958773E-030",
        "138.00",
        "9.99000000000000E+002",
        "1.48343448441303E-030",
        "138.10",
        "1.00100000000000E+003",
        "1.48563979438899E-030",
        "138.20",
        "9.98000000000000E+002",
        "1.47994045015953E-030",
        "138.30",
        "1.00100000000000E+003",
        "1.48027548100696E-030",
        "138.40",
        "9.98000000000000E+002",
        "1.47277404576758E-030",
        "138.50",
        "1.00100000000000E+003",
        "1.47409145031954E-030",
        "138.60",
        "9.99000000000000E+002",
        "1.46843875821093E-030",
        "138.70",
        "1.00100000000000E+003",
        "1.46920548059671E-030",
        "138.80",
        "1.00000000000000E+003",
        "1.46282854510312E-030",
        "138.90",
        "9.99000000000000E+002",
        "1.45959419949399E-030",
        "139.00",
        "1.00100000000000E+003",
        "1.45958307434604E-030",
        "139.10",
        "9.99000000000000E+002",
        "1.45551706139051E-030",
        "139.20",
        "1.00100000000000E+003",
        "1.45363056365902E-030",
        "139.30",
        "9.99000000000000E+002",
        "1.44791185018689E-030",
        "139.40",
        "1.00100000000000E+003",
        "1.44741726670243E-030",
        "139.50",
        "9.99000000000000E+002",
        "1.44428980247812E-030",
        "139.60",
        "1.00000000000000E+003",
        "1.44195414110206E-030",
        "139.70",
        "1.00000000000000E+003",
        "1.43922630054654E-030",
        "139.80",
        "9.98000000000000E+002",
        "1.43464587747736E-030",
        "139.90",
        "1.00100000000000E+003",
        "1.43639984617896E-030",
        "140.00",
        "9.99000000000000E+002",
        "1.42991672923378E-030",
        "140.10",
        "1.00100000000000E+003",
        "1.42941210510588E-030",
        "140.20",
        "9.99000000000000E+002",
        "1.42353754108755E-030",
        "140.30",
        "1.00000000000000E+003",
        "1.42274991547070E-030",
        "140.40",
        "9.99000000000000E+002",
        "1.41970876501155E-030",
        "140.50",
        "1.00100000000000E+003",
        "1.42007253613376E-030",
        "140.60",
        "9.99000000000000E+002",
        "1.41414667119267E-030",
        "140.70",
        "9.98000000000000E+002",
        "1.40986893794220E-030",
        "140.80",
        "1.00100000000000E+003",
        "1.41163025266889E-030",
        "140.90",
        "9.97000000000000E+002",
        "1.40303124972185E-030",
        "141.00",
        "1.00100000000000E+003",
        "1.40560709737355E-030",
        "141.10",
        "9.99000000000000E+002",
        "1.40071832137166E-030",
        "141.20",
        "1.00100000000000E+003",
        "1.39881344865903E-030",
        "141.30",
        "9.99000000000000E+002",
        "1.39603669379789E-030",
        "141.40",
        "1.00100000000000E+003",
        "1.39648705533077E-030",
        "141.50",
        "1.00000000000000E+003",
        "1.39168864384664E-030",
        "141.60",
        "9.99000000000000E+002",
        "1.38753015308627E-030",
        "141.70",
        "1.00100000000000E+003",
        "1.38570112081237E-030",
        "141.80",
        "9.99000000000000E+002",
        "1.38067614496230E-030",
        "141.90",
        "1.00000000000000E+003",
        "1.38079081475388E-030",
        "142.00",
        "9.98000000000000E+002",
        "1.37625696675309E-030",
        "142.10",
        "1.00100000000000E+003",
        "1.37752473423048E-030",
        "142.20",
        "9.99000000000000E+002",
        "1.37182609545273E-030",
        "142.30",
        "1.00100000000000E+003",
        "1.37241272925520E-030",
        "142.40",
        "9.99000000000000E+002",
        "1.36731601579622E-030",
        "142.50",
        "9.98000000000000E+002",
        "1.36162796038397E-030",
        "142.60",
        "1.00100000000000E+003",
        "1.36287041674193E-030",
        "142.70",
        "9.98000000000000E+002",
        "1.35773594876701E-030",
        "142.80",
        "9.99000000000000E+002",
        "1.35740103961683E-030",
        "142.90",
        "9.98000000000000E+002",
        "1.35258119461485E-030",
        "143.00",
        "1.00100000000000E+003",
        "1.35351542547445E-030",
        "143.10",
        "9.99000000000000E+002",
        "1.34889962900740E-030",
        "143.20",
        "9.99000000000000E+002",
        "1.34617715521261E-030",
        "143.30",
        "1.00000000000000E+003",
        "1.34394949680600E-030",
        "143.40",
        "9.99000000000000E+002",
        "1.34137040883618E-030",
        "143.50",
        "1.00000000000000E+003",
        "1.34132031762389E-030",
        "143.60",
        "9.98000000000000E+002",
        "1.33583729191291E-030",
        "143.70",
        "9.99000000000000E+002",
        "1.33518049996441E-030",
        "143.80",
        "9.99000000000000E+002",
        "1.33229647196227E-030",
        "143.90",
        "1.00100000000000E+003",
        "1.33120959838936E-030",
        "144.00",
        "9.99000000000000E+002",
        "1.32749110989917E-030",
        "144.10",
        "1.00100000000000E+003",
        "1.32728371308244E-030",
        "144.20",
        "1.00000000000000E+003",
        "1.32306655407709E-030",
        "144.30",
        "9.99000000000000E+002",
        "1.31993022171670E-030",
        "144.40",
        "1.00100000000000E+003",
        "1.31992710598899E-030",
        "144.50",
        "9.98000000000000E+002",
        "1.31343662574242E-030",
        "144.60",
        "1.00100000000000E+003",
        "1.31399566435401E-030",
        "144.70",
        "9.99000000000000E+002",
        "1.31086538981623E-030",
        "144.80",
        "1.00100000000000E+003",
        "1.30906452462772E-030",
        "144.90",
        "9.99000000000000E+002",
        "1.30544511969251E-030",
        "145.00",
        "1.00000000000000E+003",
        "1.30405449486091E-030",
        "145.10",
        "1.00000000000000E+003",
        "1.30244388849977E-030",
        "145.20",
        "9.99000000000000E+002",
        "1.29821991400321E-030",
        "145.30",
        "9.99000000000000E+002",
        "1.29553768420805E-030",
        "145.40",
        "9.98000000000000E+002",
        "1.29270101750336E-030",
        "145.50",
        "1.00100000000000E+003",
        "1.29482306293557E-030",
        "145.60",
        "9.99000000000000E+002",
        "1.28940766289169E-030",
        "145.70",
        "1.00100000000000E+003",
        "1.28984358670650E-030",
        "145.80",
        "9.96000000000000E+002",
        "1.28145281971890E-030",
        "145.90",
        "1.00000000000000E+003",
        "1.28353331343351E-030",
        "146.00",
        "1.00100000000000E+003",
        "1.28136707063838E-030",
        "146.10",
        "9.98000000000000E+002",
        "1.27509977896649E-030",
        "146.20",
        "1.00100000000000E+003",
        "1.27739679523675E-030",
        "146.30",
        "9.99000000000000E+002",
        "1.27157840319401E-030",
        "146.40",
        "1.00100000000000E+003",
        "1.27211485435588E-030",
        "146.50",
        "9.98000000000000E+002",
        "1.26671870816111E-030",
        "146.60",
        "1.00100000000000E+003",
        "1.26699040719407E-030",
        "146.70",
        "9.98000000000000E+002",
        "1.26230735525255E-030",
        "146.80",
        "1.00000000000000E+003",
        "1.26199662951266E-030",
        "146.90",
        "1.00100000000000E+003",
        "1.26056203185257E-030",
        "147.00",
        "9.98000000000000E+002",
        "1.25581686546837E-030",
        "147.10",
        "1.00100000000000E+003",
        "1.25561951376451E-030",
        "147.20",
        "9.98000000000000E+002",
        "1.25039792429341E-030",
        "147.30",
        "1.00000000000000E+003",
        "1.25086219563053E-030",
        "147.40",
        "9.99000000000000E+002",
        "1.24550523368039E-030",
        "147.50",
        "1.00100000000000E+003",
        "1.24752533508127E-030",
        "147.60",
        "9.97000000000000E+002",
        "1.23978403511484E-030",
        "147.70",
        "9.99000000000000E+002",
        "1.24012048037286E-030",
        "147.80",
        "9.98000000000000E+002",
        "1.23721409329835E-030",
        "147.90",
        "9.99000000000000E+002",
        "1.23498636679175E-030",
        "148.00",
        "1.00100000000000E+003",
        "1.23708496423563E-030",
        "148.10",
        "9.99000000000000E+002",
        "1.22983618106462E-030",
        "148.20",
        "1.00100000000000E+003",
        "1.23073364506223E-030",
        "148.30",
        "9.99000000000000E+002",
        "1.22680166837218E-030",
        "148.40",
        "1.00100000000000E+003",
        "1.22684990121191E-030",
        "148.50",
        "9.99000000000000E+002",
        "1.22340105864876E-030",
        "148.60",
        "1.00000000000000E+003",
        "1.22192874790948E-030",
        "148.70",
        "1.00000000000000E+003",
        "1.21953576405629E-030",
        "148.80",
        "9.99000000000000E+002",
        "1.21743867096841E-030",
        "148.90",
        "1.00100000000000E+003",
        "1.21651590218690E-030",
        "149.00",
        "9.98000000000000E+002",
        "1.21256339134539E-030",
        "149.10",
        "1.00100000000000E+003",
        "1.21147940770435E-030",
        "149.20",
        "9.99000000000000E+002",
        "1.20685677135304E-030",
        "149.30",
        "9.97000000000000E+002",
        "1.20255890449900E-030",
        "149.40",
        "1.00000000000000E+003",
        "1.20457368126729E-030",
        "149.50",
        "9.99000000000000E+002",
        "1.20095461313729E-030",
        "149.60",
        "1.00100000000000E+003",
        "1.20196346938922E-030",
        "149.70",
        "9.98000000000000E+002",
        "1.19510720942224E-030",
        "149.80",
        "1.00100000000000E+003",
        "1.19733819484757E-030",
        "149.90",
        "9.99000000000000E+002",
        "1.19238403452935E-030",
        "150.00",
        "9.99000000000000E+002",
        "1.19002850990770E-030",
        "150.10",
        "9.98000000000000E+002",
        "1.18799014941516E-030",
        "150.20",
        "1.00000000000000E+003",
        "1.18787781511843E-030",
        "150.30",
        "1.00000000000000E+003",
        "1.18589324795600E-030",
        "150.40",
        "9.99000000000000E+002",
        "1.18202063310756E-030",
        "150.50",
        "1.00100000000000E+003",
        "1.18286860322172E-030",
        "150.60",
        "9.98000000000000E+002",
        "1.17596561649789E-030",
        "150.70",
        "1.00100000000000E+003",
        "1.17933618596892E-030",
        "150.80",
        "9.98000000000000E+002",
        "1.17331636226348E-030",
        "150.90",
        "1.00100000000000E+003",
        "1.17307206399774E-030",
        "151.00",
        "9.99000000000000E+002",
        "1.17035616516761E-030",
        "151.10",
        "1.00100000000000E+003",
        "1.17060436588270E-030",
        "151.20",
        "1.00000000000000E+003",
        "1.16790648688363E-030",
        "151.30",
        "9.99000000000000E+002",
        "1.16460653772689E-030",
        "151.40",
        "1.00100000000000E+003",
        "1.16311589930254E-030",
        "151.50",
        "9.99000000000000E+002",
        "1.15945725177557E-030",
        "151.60",
        "1.00100000000000E+003",
        "1.15898188633217E-030",
        "151.70",
        "9.98000000000000E+002",
        "1.15444987100854E-030",
        "151.80",
        "1.00000000000000E+003",
        "1.15484845661329E-030",
        "151.90",
        "9.99000000000000E+002",
        "1.15107541358442E-030",
        "152.00",
        "9.99000000000000E+002",
        "1.14951989252024E-030",
        "152.10",
        "1.00000000000000E+003",
        "1.14827781771914E-030",
        "152.20",
        "9.99000000000000E+002",
        "1.14510524033883E-030",
        "152.30",
        "1.00100000000000E+003",
        "1.14491972848600E-030",
        "152.40",
        "9.99000000000000E+002",
        "1.14186178021408E-030",
        "152.50",
        "1.00100000000000E+003",
        "1.14147408824391E-030",
        "152.60",
        "9.99000000000000E+002",
        "1.13633736305347E-030",
        "152.70",
        "1.00000000000000E+003",
        "1.13654209281299E-030",
        "152.80",
        "9.99000000000000E+002",
        "1.13209616102807E-030",
        "152.90",
        "9.99000000000000E+002",
        "1.13205360599408E-030",
        "153.00",
        "1.00100000000000E+003",
        "1.13137166430316E-030",
        "153.10",
        "9.97000000000000E+002",
        "1.12489577411637E-030",
        "153.20",
        "1.00100000000000E+003",
        "1.12808031335590E-030",
        "153.30",
        "9.99000000000000E+002",
        "1.12356934910305E-030",
        "153.40",
        "1.00000000000000E+003",
        "1.12338739035893E-030",
        "153.50",
        "9.98000000000000E+002",
        "1.11898198018932E-030",
        "153.60",
        "1.00000000000000E+003",
        "1.11936099407173E-030",
        "153.70",
        "9.98000000000000E+002",
        "1.11414168511222E-030",
        "153.80",
        "9.99000000000000E+002",
        "1.11343791264045E-030",
        "153.90",
        "1.00000000000000E+003",
        "1.11319587775134E-030",
        "154.00",
        "9.99000000000000E+002",
        "1.11109676182405E-030",
        "154.10",
        "1.00100000000000E+003",
        "1.11034529290714E-030",
        "154.20",
        "9.99000000000000E+002",
        "1.10600547379854E-030",
        "154.30",
        "1.00100000000000E+003",
        "1.10614943253222E-030",
        "154.40",
        "9.98000000000000E+002",
        "1.10156759968948E-030",
        "154.50",
        "1.00100000000000E+003",
        "1.10388517350234E-030",
        "154.60",
        "1.00000000000000E+003",
        "1.10021559613786E-030",
        "154.70",
        "9.99000000000000E+002",
        "1.09765146638162E-030",
        "154.80",
        "1.00100000000000E+003",
        "1.09767181073742E-030",
        "154.90",
        "9.99000000000000E+002",
        "1.09173385684975E-030",
        "155.00",
        "1.00100000000000E+003",
        "1.09340671514855E-030",
        "155.10",
        "9.98000000000000E+002",
        "1.08841818484882E-030",
        "155.20",
        "1.00000000000000E+003",
        "1.08849008568965E-030",
        "155.30",
        "9.97000000000000E+002",
        "1.08327450972972E-030",
        "155.40",
        "1.00100000000000E+003",
        "1.08488142652163E-030",
        "155.50",
        "1.00000000000000E+003",
        "1.08292927572322E-030",
        "155.60",
        "9.99000000000000E+002",
        "1.08150707113409E-030",
        "155.70",
        "9.99000000000000E+002",
        "1.07732233742049E-030",
        "155.80",
        "9.99000000000000E+002",
        "1.07496321765671E-030",
        "155.90",
        "1.00000000000000E+003",
        "1.07484377287296E-030",
        "156.00",
        "9.98000000000000E+002",
        "1.07138989884170E-030",
        "156.10",
        "1.00100000000000E+003",
        "1.07282735948300E-030",
        "156.20",
        "9.98000000000000E+002",
        "1.06821191131882E-030",
        "156.30",
        "9.99000000000000E+002",
        "1.06801277475214E-030",
        "156.40",
        "1.00100000000000E+003",
        "1.06785204183760E-030",
        "156.50",
        "9.98000000000000E+002",
        "1.06194564492393E-030",
        "156.60",
        "1.00100000000000E+003",
        "1.06283520713795E-030",
        "156.70",
        "9.99000000000000E+002",
        "1.05963203452566E-030",
        "156.80",
        "1.00100000000000E+003",
        "1.06078252684601E-030",
        "156.90",
        "9.99000000000000E+002",
        "1.05721516654406E-030",
        "157.00",
        "1.00100000000000E+003",
        "1.05675039162284E-030",
        "157.10",
        "9.98000000000000E+002",
        "1.05265416748313E-030",
        "157.20",
        "9.99000000000000E+002",
        "1.05249994630675E-030",
        "157.30",
        "9.98000000000000E+002",
        "1.04934378938192E-030",
        "157.40",
        "9.99000000000000E+002",
        "1.04840130625454E-030",
        "157.50",
        "1.00000000000000E+003",
        "1.04656952055440E-030",
        "157.60",
        "9.99000000000000E+002",
        "1.04380183367001E-030",
        "157.70",
        "1.00000000000000E+003",
        "1.04355323384139E-030",
        "157.80",
        "9.99000000000000E+002",
        "1.03970355674568E-030",
        "157.90",
        "1.00100000000000E+003",
        "1.03980156569482E-030",
        "158.00",
        "9.98000000000000E+002",
        "1.03571590891254E-030",
        "158.10",
        "9.97000000000000E+002",
        "1.03217900723580E-030",
        "158.20",
        "1.00100000000000E+003",
        "1.03512957952360E-030",
        "158.30",
        "9.99000000000000E+002",
        "1.03201589328082E-030",
        "158.40",
        "1.00100000000000E+003",
        "1.03252610436812E-030",
        "158.50",
        "9.99000000000000E+002",
        "1.02883736885118E-030",
        "158.60",
        "1.00100000000000E+003",
        "1.02881215706952E-030",
        "158.70",
        "9.99000000000000E+002",
        "1.02466135716058E-030",
        "158.80",
        "1.00100000000000E+003",
        "1.02501675841879E-030",
        "158.90",
        "9.99000000000000E+002",
        "1.02150612296437E-030",
        "159.00",
        "9.99000000000000E+002",
        "1.01955574207636E-030",
        "159.10",
        "1.00000000000000E+003",
        "1.01876805862554E-030",
        "159.20",
        "9.98000000000000E+002",
        "1.01535462900656E-030",
        "159.30",
        "1.00000000000000E+003",
        "1.01647101890337E-030",
        "159.40",
        "9.99000000000000E+002",
        "1.01248720255344E-030",
        "159.50",
        "9.99000000000000E+002",
        "1.01143643661362E-030",
        "159.60",
        "9.99000000000000E+002",
        "1.00996227482527E-030",
        "159.70",
        "1.00000000000000E+003",
        "1.00853328153473E-030",
        "159.80",
        "1.00000000000000E+003",
        "1.00776312322896E-030",
        "159.90",
        "9.99000000000000E+002",
        "1.00438001906929E-030",
        "160.00",
        "1.00100000000000E+003",
        "1.00531385616237E-030",
        "160.10",
        "9.99000000000000E+002",
        "1.00154197372570E-030",
        "160.20",
        "1.00100000000000E+003",
        "1.00241180094035E-030",
        "160.30",
        "9.99000000000000E+002",
        "9.98044962485132E-031",
        "160.40",
        "1.00100000000000E+003",
        "9.97860069657399E-031",
        "160.50",
        "9.97000000000000E+002",
        "9.93193024958254E-031",
        "160.60",
        "9.99000000000000E+002",
        "9.93073560791129E-031",
        "160.70",
        "1.00100000000000E+003",
        "9.92963352437610E-031",
        "160.80",
        "9.99000000000000E+002",
        "9.89593755647903E-031",
        "160.90",
        "1.00100000000000E+003",
        "9.90904036712437E-031",
        "161.00",
        "9.99000000000000E+002",
        "9.87343289460831E-031",
        "161.10",
        "1.00000000000000E+003",
        "9.85527510585911E-031",
        "161.20",
        "9.98000000000000E+002",
        "9.82161852624380E-031",
        "161.30",
        "1.00000000000000E+003",
        "9.83056596509924E-031",
        "161.40",
        "1.00000000000000E+003",
        "9.80387829863465E-031",
        "161.50",
        "9.99000000000000E+002",
        "9.78451053989995E-031",
        "161.60",
        "1.00000000000000E+003",
        "9.77542622022508E-031",
        "161.70",
        "9.98000000000000E+002",
        "9.74180469806851E-031",
        "161.80",
        "1.00100000000000E+003",
        "9.75670948380169E-031",
        "161.90",
        "9.99000000000000E+002",
        "9.71981098206343E-031",
        "162.00",
        "1.00000000000000E+003",
        "9.70514586877550E-031",
        "162.10",
        "9.98000000000000E+002",
        "9.68129363937613E-031",
        "162.20",
        "1.00100000000000E+003",
        "9.68783527771662E-031",
        "162.30",
        "9.99000000000000E+002",
        "9.65689722044168E-031",
        "162.40",
        "9.98000000000000E+002",
        "9.64004675454583E-031",
        "162.50",
        "1.00100000000000E+003",
        "9.64682184080621E-031",
        "162.60",
        "9.98000000000000E+002",
        "9.59029597369495E-031",
        "162.70",
        "1.00100000000000E+003",
        "9.61936610532772E-031",
        "162.80",
        "9.98000000000000E+002",
        "9.56684441930660E-031",
        "162.90",
        "1.00100000000000E+003",
        "9.59121876065836E-031",
        "163.00",
        "9.99000000000000E+002",
        "9.54835895170793E-031",
        "163.10",
        "1.00000000000000E+003",
        "9.54376909800577E-031",
        "163.20",
        "1.00000000000000E+003",
        "9.52736836208418E-031",
        "163.30",
        "9.99000000000000E+002",
        "9.50054414231081E-031",
        "163.40",
        "1.00100000000000E+003",
        "9.50656976635359E-031",
        "163.50",
        "9.99000000000000E+002",
        "9.47307225628636E-031",
        "163.60",
        "1.00100000000000E+003",
        "9.47478908540759E-031",
        "163.70",
        "9.98000000000000E+002",
        "9.42359686903297E-031",
        "163.80",
        "1.00100000000000E+003",
        "9.44309007878190E-031",
        "163.90",
        "9.99000000000000E+002",
        "9.41258851766624E-031",
        "164.00",
        "1.00000000000000E+003",
        "9.40060138604391E-031",
        "164.10",
        "1.00100000000000E+003",
        "9.39420519258574E-031",
        "164.20",
        "9.99000000000000E+002",
        "9.36313540182130E-031",
        "164.30",
        "1.00100000000000E+003",
        "9.35921652073804E-031",
        "164.40",
        "9.99000000000000E+002",
        "9.33392148095701E-031",
        "164.50",
        "1.00100000000000E+003",
        "9.32792505291935E-031",
        "164.60",
        "9.99000000000000E+002",
        "9.30587539182162E-031",
        "164.70",
        "1.00100000000000E+003",
        "9.30566481623331E-031",
        "164.80",
        "9.99000000000000E+002",
        "9.27385958606124E-031",
        "164.90",
        "9.99000000000000E+002",
        "9.26500622487626E-031",
        "165.00",
        "9.99000000000000E+002",
        "9.24998498779084E-031",
        "165.10",
        "9.99000000000000E+002",
        "9.22878788070524E-031",
        "165.20",
        "1.00100000000000E+003",
        "9.23331938678773E-031",
        "165.30",
        "9.99000000000000E+002",
        "9.20138384115703E-031",
        "165.40",
        "1.00100000000000E+003",
        "9.20245344724585E-031",
        "165.50",
        "9.98000000000000E+002",
        "9.16245460181931E-031",
        "165.60",
        "1.00100000000000E+003",
        "9.16790906086017E-031",
        "165.70",
        "1.00000000000000E+003",
        "9.14354243996668E-031",
        "165.80",
        "9.99000000000000E+002",
        "9.11824795350665E-031",
        "165.90",
        "1.00100000000000E+003",
        "9.12432687378621E-031",
        "166.00",
        "9.97000000000000E+002",
        "9.07759738481279E-031",
        "166.10",
        "1.00000000000000E+003",
        "9.09233735839503E-031",
        "166.20",
        "9.98000000000000E+002",
        "9.05513106074693E-031",
        "166.30",
        "1.00000000000000E+003",
        "9.06082306336236E-031",
        "166.40",
        "9.98000000000000E+002",
        "9.03172492902910E-031",
        "166.50",
        "9.98000000000000E+002",
        "9.01177787420981E-031",
        "166.60",
        "1.00100000000000E+003",
        "9.03117262601951E-031",
        "166.70",
        "9.99000000000000E+002",
        "8.97836178043439E-031",
        "166.80",
        "1.00100000000000E+003",
        "9.00173829307379E-031",
        "166.90",
        "9.97000000000000E+002",
        "8.94170753410906E-031",
        "167.00",
        "1.00000000000000E+003",
        "8.96315693119794E-031",
        "167.10",
        "9.99000000000000E+002",
        "8.93947917358652E-031",
        "167.20",
        "1.00100000000000E+003",
        "8.94391345507823E-031",
        "167.30",
        "9.99000000000000E+002",
        "8.91077330029900E-031",
        "167.40",
        "9.98000000000000E+002",
        "8.89200711050184E-031",
        "167.50",
        "1.00000000000000E+003",
        "8.88725535498206E-031",
        "167.60",
        "9.99000000000000E+002",
        "8.87009464613326E-031",
        "167.70",
        "1.00000000000000E+003",
        "8.86401447889294E-031",
        "167.80",
        "9.98000000000000E+002",
        "8.82712510487927E-031",
        "167.90",
        "1.00000000000000E+003",
        "8.83060104960491E-031",
        "168.00",
        "9.98000000000000E+002",
        "8.79268284978188E-031",
        "168.10",
        "1.00100000000000E+003",
        "8.80671993009796E-031",
        "168.20",
        "1.00000000000000E+003",
        "8.78714060449306E-031",
        "168.30",
        "9.98000000000000E+002",
        "8.76214119216897E-031",
        "168.40",
        "1.00000000000000E+003",
        "8.76267639199579E-031",
        "168.50",
        "9.98000000000000E+002",
        "8.73546821236409E-031",
        "168.60",
        "1.00100000000000E+003",
        "8.75173179101434E-031",
        "168.70",
        "9.99000000000000E+002",
        "8.71378873572555E-031",
        "168.80",
        "9.99000000000000E+002",
        "8.70601393591410E-031",
        "168.90",
        "9.99000000000000E+002",
        "8.68544740942914E-031",
        "169.00",
        "1.00000000000000E+003",
        "8.67637497817826E-031",
        "169.10",
        "1.00100000000000E+003",
        "8.67646036422148E-031",
        "169.20",
        "9.98000000000000E+002",
        "8.63386964838799E-031",
        "169.30",
        "1.00100000000000E+003",
        "8.64891121337411E-031",
        "169.40",
        "9.99000000000000E+002",
        "8.61365312978571E-031",
        "169.50",
        "1.00100000000000E+003",
        "8.61808666920341E-031",
        "169.60",
        "9.99000000000000E+002",
        "8.58699356956949E-031",
        "169.70",
        "1.00000000000000E+003",
        "8.58226364109279E-031",
        "169.80",
        "9.99000000000000E+002",
        "8.56639286687257E-031",
        "169.90",
        "1.00000000000000E+003",
        "8.55824202112021E-031",
        "170.00",
        "1.00100000000000E+003",
        "8.55553221957545E-031",
        "170.10",
        "9.98000000000000E+002",
        "8.51723031676650E-031",
        "170.20",
        "1.00100000000000E+003",
        "8.51965234719868E-031",
        "170.30",
        "9.98000000000000E+002",
        "8.48918955118245E-031",
        "170.40",
        "1.00100000000000E+003",
        "8.50228344759713E-031",
        "170.50",
        "9.99000000000000E+002",
        "8.47308618638707E-031",
        "170.60",
        "9.99000000000000E+002",
        "8.46116541767769E-031",
        "170.70",
        "1.00000000000000E+003",
        "8.45286125026339E-031",
        "170.80",
        "9.98000000000000E+002",
        "8.42313464711856E-031",
        "170.90",
        "1.00000000000000E+003",
        "8.42665821492142E-031",
        "171.00",
        "9.99000000000000E+002",
        "8.40124053713247E-031",
        "171.10",
        "1.00100000000000E+003",
        "8.41669650340643E-031",
        "171.20",
        "9.99000000000000E+002",
        "8.38095326214723E-031",
        "171.30",
        "1.00100000000000E+003",
        "8.38059202843079E-031",
        "171.40",
        "9.99000000000000E+002",
        "8.34814628162728E-031",
        "171.50",
        "1.00000000000000E+003",
        "8.35581003228947E-031",
        "171.60",
        "1.00000000000000E+003",
        "8.33872856927906E-031",
        "171.70",
        "9.98000000000000E+002",
        "8.30972651334154E-031",
        "171.80",
        "1.00100000000000E+003",
        "8.32126641660124E-031",
        "171.90",
        "9.98000000000000E+002",
        "8.27988707725855E-031",
        "172.00",
        "1.00100000000000E+003",
        "8.28845136948935E-031",
        "172.10",
        "9.98000000000000E+002",
        "8.25169766609215E-031",
        "172.20",
        "1.00100000000000E+003",
        "8.26234142684375E-031",
        "172.30",
        "9.99000000000000E+002",
        "8.23533608651837E-031",
        "172.40",
        "9.98000000000000E+002",
        "8.22596144563029E-031",
        "172.50",
        "1.00100000000000E+003",
        "8.23262447648670E-031",
        "172.60",
        "9.98000000000000E+002",
        "8.18335423373291E-031",
        "172.70",
        "1.00100000000000E+003",
        "8.19999142051887E-031",
        "172.80",
        "9.99000000000000E+002",
        "8.16661874703499E-031",
        "172.90",
        "1.00000000000000E+003",
        "8.16664713920595E-031",
        "173.00",
        "9.97000000000000E+002",
        "8.13193907923233E-031",
        "173.10",
        "1.00100000000000E+003",
        "8.15504840540594E-031",
        "173.20",
        "1.00000000000000E+003",
        "8.13255761638722E-031",
        "173.30",
        "9.99000000000000E+002",
        "8.11897252586375E-031",
        "173.40",
        "1.00100000000000E+003",
        "8.11237003440323E-031",
        "173.50",
        "9.99000000000000E+002",
        "8.08670558967061E-031",
        "173.60",
        "1.00100000000000E+003",
        "8.09470620324570E-031",
        "173.70",
        "9.99000000000000E+002",
        "8.05726821218467E-031",
        "173.80",
        "9.98000000000000E+002",
        "8.03594670323655E-031",
        "173.90",
        "9.99000000000000E+002",
        "8.03299477235270E-031",
        "174.00",
        "9.99000000000000E+002",
        "8.02559228548051E-031",
        "174.10",
        "1.00000000000000E+003",
        "8.02209766400760E-031",
        "174.20",
        "9.98000000000000E+002",
        "7.99093303473988E-031",
        "174.30",
        "1.00100000000000E+003",
        "8.00455526470480E-031",
        "174.40",
        "9.98000000000000E+002",
        "7.96654796316486E-031",
        "174.50",
        "1.00000000000000E+003",
        "7.96986559794855E-031",
        "174.60",
        "9.99000000000000E+002",
        "7.94970167902129E-031",
        "174.70",
        "1.00100000000000E+003",
        "7.95297296175363E-031",
        "174.80",
        "1.00000000000000E+003",
        "7.93079648429331E-031",
        "174.90",
        "9.99000000000000E+002",
        "7.90689222532122E-031",
        "175.00",
        "9.99000000000000E+002",
        "7.90070273518440E-031",
        "175.10",
        "9.98000000000000E+002",
        "7.88083687149426E-031",
        "175.20",
        "1.00100000000000E+003",
        "7.89432677284490E-031",
        "175.30",
        "9.99000000000000E+002",
        "7.87239342169923E-031",
        "175.40",
        "1.00000000000000E+003",
        "7.85597662355936E-031",
        "175.50",
        "9.99000000000000E+002",
        "7.84326816011438E-031",
        "175.60",
        "1.00000000000000E+003",
        "7.83530263619204E-031",
        "175.70",
        "9.96000000000000E+002",
        "7.79634786816178E-031",
        "175.80",
        "9.99000000000000E+002",
        "7.80566208162185E-031",
        "175.90",
        "1.00100000000000E+003",
        "7.81098287333811E-031",
        "176.00",
        "9.99000000000000E+002",
        "7.78593087952062E-031",
        "176.10",
        "1.00100000000000E+003",
        "7.79247713334289E-031",
        "176.20",
        "9.99000000000000E+002",
        "7.75744958704111E-031",
        "176.30",
        "1.00000000000000E+003",
        "7.76363422873835E-031",
        "176.40",
        "9.99000000000000E+002",
        "7.74326584252025E-031",
        "176.50",
        "9.99000000000000E+002",
        "7.72345986483723E-031",
        "176.60",
        "1.00100000000000E+003",
        "7.72250961826059E-031",
        "176.70",
        "9.98000000000000E+002",
        "7.69344962007897E-031",
        "176.80",
        "9.99000000000000E+002",
        "7.69563039682832E-031",
        "176.90",
        "9.99000000000000E+002",
        "7.67865386144150E-031",
        "177.00",
        "1.00100000000000E+003",
        "7.68575681223114E-031",
        "177.10",
        "9.99000000000000E+002",
        "7.65568937726428E-031",
        "177.20",
        "1.00000000000000E+003",
        "7.65016189013835E-031",
        "177.30",
        "1.00000000000000E+003",
        "7.63966559922164E-031",
        "177.40",
        "9.99000000000000E+002",
        "7.62594743369687E-031",
        "177.50",
        "1.00000000000000E+003",
        "7.61582720557693E-031",
        "177.60",
        "9.98000000000000E+002",
        "7.59178499950544E-031",
        "177.70",
        "1.00100000000000E+003",
        "7.60667095884547E-031",
        "177.80",
        "9.99000000000000E+002",
        "7.57384844027804E-031",
        "177.90",
        "1.00100000000000E+003",
        "7.58698571889849E-031",
        "178.00",
        "9.97000000000000E+002",
        "7.54188428688695E-031",
        "178.10",
        "1.00100000000000E+003",
        "7.55721472556154E-031",
        "178.20",
        "9.99000000000000E+002",
        "7.53169678462670E-031",
        "178.30",
        "9.98000000000000E+002",
        "7.51217432489480E-031",
        "178.40",
        "1.00100000000000E+003",
        "7.51991041454762E-031",
        "178.50",
        "9.98000000000000E+002",
        "7.49621189245700E-031",
        "178.60",
        "1.00100000000000E+003",
        "7.50133572203456E-031",
        "178.70",
        "9.98000000000000E+002",
        "7.46929167403130E-031",
        "178.80",
        "1.00100000000000E+003",
        "7.47795228194472E-031",
        "178.90",
        "9.99000000000000E+002",
        "7.44885363630412E-031",
        "179.00",
        "9.99000000000000E+002",
        "7.44171663139026E-031",
        "179.10",
        "1.00100000000000E+003",
        "7.44334249804739E-031",
        "179.20",
        "9.97000000000000E+002",
        "7.40817536067934E-031",
        "179.30",
        "1.00000000000000E+003",
        "7.41627468712142E-031",
        "179.40",
        "9.99000000000000E+002",
        "7.40284413395121E-031",
        "179.50",
        "1.00000000000000E+003",
        "7.39805281418018E-031",
        "179.60",
        "9.98000000000000E+002",
        "7.37563944040703E-031",
        "179.70",
        "1.00100000000000E+003",
        "7.38011125077633E-031",
        "179.80",
        "9.98000000000000E+002",
        "7.34308489311866E-031",
        "179.90",
        "9.99000000000000E+002",
        "7.34294723680957E-031",
        "180.00",
        "1.00100000000000E+003",
        "7.34379115505454E-031",
        "180.10",
        "9.99000000000000E+002",
        "7.32086393178775E-031",
        "180.20",
        "1.00000000000000E+003",
        "7.31193728912616E-031",
        "180.30",
        "9.98000000000000E+002",
        "7.29833157686898E-031",
        "180.40",
        "1.00100000000000E+003",
        "7.30525390027457E-031",
        "180.50",
        "9.99000000000000E+002",
        "7.27845036883204E-031",
        "180.60",
        "9.98000000000000E+002",
        "7.26071447799906E-031",
        "180.70",
        "1.00000000000000E+003",
        "7.26823973842820E-031",
        "180.80",
        "9.95000000000000E+002",
        "7.21782643587899E-031",
        "180.90",
        "9.98000000000000E+002",
        "7.22794659792493E-031",
        "181.00",
        "9.99000000000000E+002",
        "7.23095057242158E-031",
        "181.10",
        "1.00100000000000E+003",
        "7.23385698332644E-031",
        "181.20",
        "9.99000000000000E+002",
        "7.20578164510761E-031",
        "181.30",
        "1.00100000000000E+003",
        "7.20848311979828E-031",
        "181.40",
        "1.00000000000000E+003",
        "7.18316003459844E-031",
        "181.50",
        "9.99000000000000E+002",
        "7.17465861584898E-031",
        "181.60",
        "1.00100000000000E+003",
        "7.17283154288323E-031",
        "181.70",
        "9.99000000000000E+002",
        "7.15364753694604E-031",
        "181.80",
        "1.00100000000000E+003",
        "7.15429334881717E-031",
        "181.90",
        "9.99000000000000E+002",
        "7.12482032186268E-031",
        "182.00",
        "1.00000000000000E+003",
        "7.12916166895072E-031",
        "182.10",
        "9.97000000000000E+002",
        "7.09849936265455E-031",
        "182.20",
        "1.00100000000000E+003",
        "7.11498997992337E-031",
        "182.30",
        "1.00000000000000E+003",
        "7.09867415588590E-031",
        "182.40",
        "9.99000000000000E+002",
        "7.07667906791564E-031",
        "182.50",
        "1.00100000000000E+003",
        "7.08182642953863E-031",
        "182.60",
        "9.99000000000000E+002",
        "7.05369271125715E-031",
        "182.70",
        "1.00000000000000E+003",
        "7.05567711169577E-031",
        "182.80",
        "9.99000000000000E+002",
        "7.02621260130207E-031",
        "182.90",
        "1.00100000000000E+003",
        "7.03790254817356E-031",
        "183.00",
        "9.97000000000000E+002",
        "7.00196571024869E-031",
        "183.10",
        "9.99000000000000E+002",
        "7.00717957611646E-031",
        "183.20",
        "1.00100000000000E+003",
        "7.01006514049897E-031",
        "183.30",
        "9.98000000000000E+002",
        "6.98115376593532E-031",
        "183.40",
        "1.00100000000000E+003",
        "6.99255600378397E-031",
        "183.50",
        "9.97000000000000E+002",
        "6.95015368252505E-031",
        "183.60",
        "9.99000000000000E+002",
        "6.95398117597177E-031",
        "183.70",
        "9.98000000000000E+002",
        "6.93708613988754E-031",
        "183.80",
        "1.00100000000000E+003",
        "6.94452353921910E-031",
        "183.90",
        "9.99000000000000E+002",
        "6.92793194414492E-031",
        "184.00",
        "9.97000000000000E+002",
        "6.90087370324559E-031",
        "184.10",
        "1.00100000000000E+003",
        "6.91541525777931E-031",
        "184.20",
        "9.98000000000000E+002",
        "6.89227133852741E-031",
        "184.30",
        "1.00100000000000E+003",
        "6.90017508314582E-031",
        "184.40",
        "9.99000000000000E+002",
        "6.87692683833745E-031",
        "184.50",
        "1.00000000000000E+003",
        "6.86701630801488E-031",
        "184.60",
        "9.98000000000000E+002",
        "6.84516916601963E-031",
        "184.70",
        "9.97000000000000E+002",
        "6.83040257458046E-031",
        "184.80",
        "1.00100000000000E+003",
        "6.85392006074526E-031",
        "184.90",
        "9.99000000000000E+002",
        "6.82641617563507E-031",
        "185.00",
        "1.00100000000000E+003",
        "6.83216048361027E-031",
        "185.10",
        "9.98000000000000E+002",
        "6.79858688408244E-031",
        "185.20",
        "9.99000000000000E+002",
        "6.79719821517206E-031",
        "185.30",
        "9.99000000000000E+002",
        "6.78416704832868E-031",
        "185.40",
        "1.00100000000000E+003",
        "6.79083879749704E-031",
        "185.50",
        "9.99000000000000E+002",
        "6.76924570878769E-031",
        "185.60",
        "9.99000000000000E+002",
        "6.75788522506201E-031",
        "185.70",
        "1.00100000000000E+003",
        "6.76092254424813E-031",
        "185.80",
        "9.96000000000000E+002",
        "6.71855277286743E-031",
        "185.90",
        "1.00100000000000E+003",
        "6.74521076623761E-031",
        "186.00",
        "9.99000000000000E+002",
        "6.71452904880057E-031",
        "186.10",
        "1.00100000000000E+003",
        "6.72216211361704E-031",
        "186.20",
        "1.00600000000000E+003",
        "6.74535383773556E-031",
        "186.30",
        "9.92000000000000E+002",
        "6.64409152102911E-031",
        "186.40",
        "1.00900000000000E+003",
        "6.74847765597962E-031",
        "186.50",
        "9.92000000000000E+002",
        "6.62317478933023E-031",
        "186.60",
        "9.91000000000000E+002",
        "6.60893605577304E-031",
        "186.70",
        "1.01100000000000E+003",
        "6.73038409440414E-031",
        "186.80",
        "9.92000000000000E+002",
        "6.59548934248657E-031",
        "186.90",
        "1.01000000000000E+003",
        "6.70334623841257E-031",
        "187.00",
        "9.92000000000000E+002",
        "6.57484061966160E-031",
        "187.10",
        "1.01000000000000E+003",
        "6.68418848088861E-031",
        "187.20",
        "9.91000000000000E+002",
        "6.54910006382985E-031",
        "187.30",
        "1.00900000000000E+003",
        "6.66315731417584E-031",
        "187.40",
        "9.91000000000000E+002",
        "6.52966224609134E-031",
        "187.50",
        "9.91000000000000E+002",
        "6.52427279008537E-031",
        "187.60",
        "1.00900000000000E+003",
        "6.63393980222628E-031",
        "187.70",
        "9.92000000000000E+002",
        "6.51366434817147E-031",
        "187.80",
        "1.00900000000000E+003",
        "6.61527991344088E-031",
        "187.90",
        "9.91000000000000E+002",
        "6.48944673950222E-031",
        "188.00",
        "1.00900000000000E+003",
        "6.59324240617163E-031",
        "188.10",
        "9.91000000000000E+002",
        "6.46877350528913E-031",
        "188.20",
        "1.01000000000000E+003",
        "6.58313823824987E-031",
        "188.30",
        "9.91000000000000E+002",
        "6.45035539064315E-031",
        "188.40",
        "9.91000000000000E+002",
        "6.44257080947479E-031",
        "188.50",
        "1.01000000000000E+003",
        "6.55893948689486E-031",
        "188.60",
        "9.92000000000000E+002",
        "6.42777569208234E-031",
        "188.70",
        "1.01000000000000E+003",
        "6.53877991230820E-031",
        "188.80",
        "9.90000000000000E+002",
        "6.39839602777378E-031",
        "188.90",
        "1.01000000000000E+003",
        "6.51674814441447E-031",
        "189.00",
        "9.92000000000000E+002",
        "6.40212443040135E-031",
        "189.10",
        "1.01000000000000E+003",
        "6.50195429441708E-031",
        "189.20",
        "9.92000000000000E+002",
        "6.37481325698240E-031",
        "189.30",
        "9.92000000000000E+002",
        "6.36386048747218E-031",
        "189.40",
        "1.01000000000000E+003",
        "6.47160338297929E-031",
        "189.50",
        "9.92000000000000E+002",
        "6.34534995097005E-031",
        "189.60",
        "1.01000000000000E+003",
        "6.45352271762092E-031",
        "189.70",
        "9.92000000000000E+002",
        "6.32974192310507E-031",
        "189.80",
        "1.00900000000000E+003",
        "6.43367480589346E-031",
        "189.90",
        "9.92000000000000E+002",
        "6.31287685028617E-031",
        "190.00",
        "1.00800000000000E+003",
        "6.40650658505812E-031",
        "190.10",
        "9.91000000000000E+002",
        "6.29006729529558E-031",
        "190.20",
        "9.91000000000000E+002",
        "6.27571174988645E-031",
        "190.30",
        "1.01000000000000E+003",
        "6.39030786550369E-031",
        "190.40",
        "9.91000000000000E+002",
        "6.26200507508988E-031",
        "190.50",
        "1.01000000000000E+003",
        "6.37093660894212E-031",
        "190.60",
        "9.92000000000000E+002",
        "6.24655007240216E-031",
        "190.70",
        "1.01000000000000E+003",
        "6.35705336543293E-031",
        "190.80",
        "9.92000000000000E+002",
        "6.22915525638476E-031",
        "190.90",
        "1.01000000000000E+003",
        "6.34021997876378E-031",
        "191.00",
        "9.91000000000000E+002",
        "6.21381814231050E-031",
        "191.10",
        "9.92000000000000E+002",
        "6.21156238740567E-031",
        "191.20",
        "1.00900000000000E+003",
        "6.30990982294628E-031",
        "191.30",
        "9.91000000000000E+002",
        "6.18649140879295E-031",
        "191.40",
        "1.00900000000000E+003",
        "6.29374836138558E-031",
        "191.50",
        "9.92000000000000E+002",
        "6.17727661097523E-031",
        "191.60",
        "1.00900000000000E+003",
        "6.26955184457386E-031",
        "191.70",
        "9.91000000000000E+002",
        "6.15161327948394E-031",
        "191.80",
        "1.01100000000000E+003",
        "6.26471571081767E-031",
        "191.90",
        "9.90000000000000E+002",
        "6.12821743004482E-031",
        "192.00",
        "9.92000000000000E+002",
        "6.12557944075404E-031",
        "192.10",
        "1.01000000000000E+003",
        "6.23419888132037E-031",
        "192.20",
        "9.92000000000000E+002",
        "6.10877586399790E-031",
        "192.30",
        "1.01000000000000E+003",
        "6.20990720223501E-031",
        "192.40",
        "9.91000000000000E+002",
        "6.08805969193412E-031",
        "192.50",
        "1.01000000000000E+003",
        "6.19624508176066E-031",
        "192.60",
        "9.91000000000000E+002",
        "6.07076758468679E-031",
        "192.70",
        "1.01100000000000E+003",
        "6.18780274968135E-031",
        "192.80",
        "9.91000000000000E+002",
        "6.05892463449825E-031",
        "192.90",
        "9.92000000000000E+002",
        "6.05579407910096E-031",
        "193.00",
        "1.00900000000000E+003",
        "6.15169599707924E-031",
        "193.10",
        "9.90000000000000E+002",
        "6.02691910025807E-031",
        "193.20",
        "1.01100000000000E+003",
        "6.14475930801973E-031",
        "193.30",
        "9.89000000000000E+002",
        "6.00371315620180E-031",
        "193.40",
        "1.00800000000000E+003",
        "6.10817169771451E-031",
        "193.50",
        "9.91000000000000E+002",
        "5.99717771769041E-031",
        "193.60",
        "1.01100000000000E+003",
        "6.11351144597073E-031",
        "193.70",
        "9.92000000000000E+002",
        "5.98725936130488E-031",
        "193.80",
        "9.91000000000000E+002",
        "5.97562230474969E-031",
        "193.90",
        "1.01000000000000E+003",
        "6.08189458355597E-031",
        "194.00",
        "9.89000000000000E+002",
        "5.94464662408977E-031",
        "194.10",
        "1.01100000000000E+003",
        "6.07263652167464E-031",
        "194.20",
        "9.90000000000000E+002",
        "5.93782482634209E-031",
        "194.30",
        "1.01000000000000E+003",
        "6.04249680271504E-031",
        "194.40",
        "9.91000000000000E+002",
        "5.92973672226838E-031",
        "194.50",
        "9.90000000000000E+002",
        "5.91467224019330E-031",
        "194.60",
        "1.01100000000000E+003",
        "6.02515336867046E-031",
        "194.70",
        "9.91000000000000E+002",
        "5.90007935798510E-031",
        "194.80",
        "1.01100000000000E+003",
        "6.01048189348105E-031",
        "194.90",
        "9.91000000000000E+002",
        "5.88252834200254E-031",
        "195.00",
        "1.01100000000000E+003",
        "5.99277960497947E-031",
        "195.10",
        "9.92000000000000E+002",
        "5.87629698022195E-031",
        "195.20",
        "1.00900000000000E+003",
        "5.96765421157376E-031",
        "195.30",
        "9.91000000000000E+002",
        "5.85423697864346E-031",
        "195.40",
        "9.91000000000000E+002",
        "5.84536227026306E-031",
        "195.50",
        "1.01100000000000E+003",
        "5.95653355360886E-031",
        "195.60",
        "9.90000000000000E+002",
        "5.82130071891774E-031",
        "195.70",
        "1.01100000000000E+003",
        "5.93723310202560E-031",
        "195.80",
        "9.90000000000000E+002",
        "5.81128857534790E-031",
        "195.90",
        "1.01000000000000E+003",
        "5.91714366764058E-031",
        "196.00",
        "9.91000000000000E+002",
        "5.80080412569717E-031",
        "196.10",
        "1.00800000000000E+003",
        "5.88642188852018E-031",
        "196.20",
        "9.90000000000000E+002",
        "5.77258653505210E-031",
        "196.30",
        "9.86000000000000E+002",
        "5.74544455220762E-031",
        "196.40",
        "1.00900000000000E+003",
        "5.86896646971223E-031",
        "196.50",
        "9.86000000000000E+002",
        "5.73520255998912E-031",
        "196.60",
        "1.00600000000000E+003",
        "5.84083727446873E-031",
        "196.70",
        "9.92000000000000E+002",
        "5.75290671621986E-031",
        "196.80",
        "1.00400000000000E+003",
        "5.80910756621993E-031",
        "196.90",
        "9.85000000000000E+002",
        "5.69619843113432E-031",
        "197.00",
        "1.00200000000000E+003",
        "5.78695498366214E-031",
        "197.10",
        "9.83000000000000E+002",
        "5.66837761012855E-031",
        "197.20",
        "9.81000000000000E+002",
        "5.64780696589240E-031",
        "197.30",
        "1.00500000000000E+003",
        "5.78221831754760E-031",
        "197.40",
        "9.81000000000000E+002",
        "5.63406198820313E-031",
        "197.50",
        "9.95000000000000E+002",
        "5.70886003166408E-031",
        "197.60",
        "9.78000000000000E+002",
        "5.60304404463488E-031",
        "197.70",
        "9.89000000000000E+002",
        "5.66414758414224E-031",
        "197.80",
        "9.65000000000000E+002",
        "5.51791383302068E-031",
        "197.90",
        "9.66000000000000E+002",
        "5.51578465561857E-031",
        "198.00",
        "9.40000000000000E+002",
        "5.36333426399912E-031",
        "198.10",
        "9.43000000000000E+002",
        "5.37189748931221E-031",
        "198.20",
        "9.57000000000000E+002",
        "5.44606059199430E-031",
        "198.30",
        "9.06000000000000E+002",
        "5.14984916529330E-031",
        "198.40",
        "9.11000000000000E+002",
        "5.17561720007583E-031",
        "198.50",
        "8.68000000000000E+002",
        "4.92366018523137E-031",
        "198.60",
        "8.66000000000000E+002",
        "4.91021657818630E-031",
        "198.70",
        "8.29000000000000E+002",
        "4.69898014870960E-031",
        "198.80",
        "8.15000000000000E+002",
        "4.61372702737059E-031",
        "198.90",
        "7.52000000000000E+002",
        "4.25489495351235E-031",
        "199.00",
        "7.36000000000000E+002",
        "4.16242693770843E-031",
        "199.10",
        "6.66000000000000E+002",
        "3.76477462356206E-031",
        "199.20",
        "5.94000000000000E+002",
        "3.35630364753997E-031",
        "199.30",
        "5.19000000000000E+002",
        "2.93146310683892E-031",
        "199.40",
        "3.96000000000000E+002",
        "2.23567270671798E-031",
        "199.50",
        "3.40000000000000E+002",
        "1.91861637872964E-031",
        "199.60",
        "2.16000000000000E+002",
        "1.21895369696876E-031",
        "199.70",
        "1.09000000000000E+002",
        "6.15230450154247E-032",
        "199.80",
        "2.80000000000000E+001",
        "1.58115205452341E-032",
        "199.90",
        "0.00000000000000E+000",
        "0.00000000000000E+000",
        "200.00",
        "0.00000000000000E+000",
        "0.00000000000000E+000"
    ]
}